import React, { useState, useEffect } from 'react';
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row, Form } from 'reactstrap';
import { toast } from 'react-toastify';
import { fetchFormData } from '../../../../Api/ApiMethods';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

import CustomerInfoForm from './CustomerInfoForm';
import ContactInfoForm from './ContactInfoForm';
import PowerOfAttorneyForm from './PowerOfAttorneyForm';
import AddressInfoForm from './AddressInfoForm';
import CallFormHeader from './CallFormHeader';
import CallFormFooter from './CallFormFooter';
import AccidentInfoForm from './AccidentInfoForm';
import DocumentRequestForm from './DocumentRequestForm';
import CommentsComponent, { callFormStateMappings } from '../Component/CommentsComponent';
import FilesComponent from '../Component/FilesComponent';
import ExpenseCardList from '../Component/ExpenseCardList';
import AccidentFileExpenseList from '../Component/AccidentFileExpenseList';
import PaymentCollectionCardList from '../Component/PaymentCollectionCardList'; // Import the new component
import ExpertForm from './ExpertForm';
import ExpertReportForm from './ExpertReportForm';
import InsuranceCompanyReportForm from './InsuranceCompanyReportForm';

// Move API URL constants outside the component to prevent unnecessary re-renders
const API_BASE_URL = process.env.REACT_APP_LACIVERT_API_ENDPOINT;
const API_ENDPOINTS = {
    callform: `${API_BASE_URL}/callform`,
    permissions: `${API_BASE_URL}/callform/state-permissions`,
    callFormState: `${API_BASE_URL}/callformstate`,
    datapool: `${API_BASE_URL}/datapool`,
    insuranceCompany: `${API_BASE_URL}/insurancecompany`,
    city: `${API_BASE_URL}/city`,
    district: `${API_BASE_URL}/district`,
    workFileType: `${API_BASE_URL}/workfiletype`,
    // Note: Removed fileType since FilesComponent handles its own file types
    customer: `${API_BASE_URL}/customer`,
    licensePlate: `${API_BASE_URL}/licenseplate`
};

const CallForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isNewFormFromDataPool = location.pathname.includes('/new-callform/');
    const callformApiUrl = API_ENDPOINTS.callform;
    const permissionsApiUrl = API_ENDPOINTS.permissions;
    const callFormStateApiUrl = API_ENDPOINTS.callFormState;
    const jobPoolApiUrl = API_ENDPOINTS.datapool;
    const insuranceCompanyApiUrl = API_ENDPOINTS.insuranceCompany;
    const cityApiUrl = API_ENDPOINTS.city;
    const districtApiUrl = API_ENDPOINTS.district;
    const workFileTypeApiUrl = API_ENDPOINTS.workFileType;
    const customerApiUrl = API_ENDPOINTS.customer;
    const licensePlateApiUrl = API_ENDPOINTS.licensePlate;

    const { id } = useParams();

    const [currentFormState, setCurrentFormState] = useState(id ? null : 'Yeni Çağrı Formu'); // Initialize state based on ID
    const [fieldPermissions, setFieldPermissions] = useState([]); // State for field permissions
    const [canEdit, setCanEdit] = useState(id ? null : true); // State for canEdit permission from API
    const [dynamicCallFormStates, setDynamicCallFormStates] = useState(null); // State for fetched form states (Name: ID)
    const [dynamicStateTransitions, setDynamicStateTransitions] = useState(null); // State for dynamic transitions (Name: { action: ID })
    const [loadingStates, setLoadingStates] = useState(true); // Loading state for form states and transitions
    const [loading, setLoading] = useState(false); // <-- Form gönderimi için loading state'i ekleyin

    const [errors, setErrors] = useState({});
    const [searchTerm, setSearchTerm] = useState(null);
    // selectedFiles state removed - FilesComponent handles its own file management
    // Removed fileTypes state since FilesComponent manages its own file types
    const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    const [workFileTypes, setWorkFileTypes] = useState([]);
    const [cities, setCities] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [filteredDistricts, setFilteredDistricts] = useState([]);
    const [existingComments, setExistingComments] = useState([]);

    const pageTitle = id ? 'Çağrı Formu' : 'Yeni Çağrı Formu';

    const [formData, setFormData] = useState({
        recipientOfPowerOfAttorney: null,
        agentId: null,
        registrationDate: null,
        clientName: null,  // Bireysel  
        companyName: null, // Kurumsal
        tcid: null, // Bireysel
        crsNumber: null, // Kurumsal
        taxNumber: null, // Kurumsal
        isThereLovClaim: null,
        hasCarSoldBefore: null,
        isTrialDocument: null,
        isWorkDocument: null,  // Changed from willLorBeWorked
        bonusEligibility: null,
        shouldPayNotaryFee: null,
        notaryFeeAmount: null,
        licensePlate: null,
        chassisNumber: null,
        carBrand: null,
        carModel: null,
        carYear: null,
        estimatedDepreciationAmount: null,
        damageAmount: null,
        damageDifferenceAmount: null,
        lorAmount: null,
        accidentDate: null,
        faultRate: null,
        phoneNumber: null,
        phoneNumber2: null,
        companyRepresentative: null, // Kurumsal
        email: null,
        email2: null,
        iban: null,
        iban2: null,
        middleman: null, // This is general middleman name, not specific to contract type logic
        middlemanIban: null, // General middleman IBAN

        // Customer Specific Contract/Middleman fields
        customerContractRate: null,
        customerIsMiddlemanContractBased: false,
        customerMiddlemanContractRate: null,
        customerMiddlemanContractPrice: null,

        isPowerOfAttorneyTimed: null,
        powerOfAttorneyDate: null,
        powerOfAttorneyEndDate: null,
        powerOfAttorneyNumber: null,
        notaryNumber: null,
        // contractRate: null, // Replaced by customerContractRate and licensePlateCustomerContractRate
        isLicensePlatesLimited: null,
        plateLimit: [],
        isAccidentDateLimited: null,
        plateLimitAccidentDate: null,
        hasOriginalArrived: null,
        hasContractArrived: null,
        reference: null,
        city: null,
        district: null,
        address: null,
        notes: null,
        customerType: 'Bireysel',

        // License Plate Specific Contract/Middleman fields
        licensePlateCustomerContractRate: null,
        licensePlateIsMiddlemanContractBased: false,
        licensePlateMiddlemanContractRate: null,
        licensePlateMiddlemanContractPrice: null,

        isThereOpenDamageFile: null,
        jobToBeWorked: null,
        whoseInsurance: null,
        documentRequestDate: null,
        documentRequestStatus: null,
        documentReceivedDate: null,

        filesToBeWorked: [],

        trafficInsurancePolicy: {
            trafficInsuranceProvider: [],
            trafficInsuranceNumber: null,
            trafficInsuranceExpiry: null,
            trafficInsuranceStart: null,
        },

        cascoInsurancePolicy: {
            cascoInsuranceProvider: [],
            cascoInsuranceNumber: null,
            cascoInsuranceExpiry: null,
            cascoInsuranceStart: null,
        },

        counterpartyType: 'Bireysel',
        counterpartyIdentificationNumber: null,
        counterpartyTaxNumber: null,
        counterpartyCarOwner: null,
        counterpartyLicensePlateNumber: null,
        counterpartyAddress: null,

        counterpartyTrafficInsurancePolicy: {
            trafficInsuranceProvider: [],
            trafficInsuranceNumber: null,
            trafficInsuranceExpiry: null,
            trafficInsuranceStart: null,
        },

        counterpartyCascoInsurancePolicy: {
            cascoInsuranceProvider: [],
            cascoInsuranceNumber: null,
            cascoInsuranceExpiry: null,
            cascoInsuranceStart: null,
        },

        ourFaultRate: null,
        counterpartyFaultRate: null,

        willLorBeWorked: "no",
    }); 
    
    const [accidentFileId, setAccidentFileId] = useState(null);
    const [customerId, setCustomerId] = useState(null);
    const [powerOfAttorneyId, setPowerOfAttorneyId] = useState(null);
    const [accidentFiles, setAccidentFiles] = useState([]);

    // Function to fetch field permissions
    const fetchFieldPermissions = async (stateId) => {
        if (!stateId) {
            console.warn("State ID is required to fetch permissions.");
            setFieldPermissions([]); // Reset or set default permissions if stateId is missing
            return;
        }
        try {
            const apiUrl = `${permissionsApiUrl}?stateId=${stateId}`;
            console.log('Fetching permissions from:', apiUrl);

            // --- Token Ekleme Başlangıç ---
            const accessToken = localStorage.getItem('accessToken'); // 'accessToken' olarak güncellendi
            if (!accessToken) {
                console.error('Authorization token not found for fetching permissions!');
                toast.error('Yetkilendirme hatası: Token bulunamadı.');
                // İsteği durdurmak veya varsayılan izinleri ayarlamak isteyebilirsiniz
                setFieldPermissions([]);
                return;
            }
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
            };
            // --- Token Ekleme Bitiş ---

            const response = await axios.get(apiUrl, { headers }); // <-- Header'ları ekle
            if (response.data && response.data.isSuccess && response.data.data) {
                setFieldPermissions(response.data.data.fieldPermissions || []);
                console.log('Field permissions loaded:', response.data.data.fieldPermissions);
            } else {
                console.error('Failed to fetch or parse permissions:', response.data);
                toast.error('Alan izinleri yüklenemedi.');
                setFieldPermissions([]); // Reset permissions on failure
            }
        } catch (error) {
            console.error('Error fetching field permissions:', error);
            toast.error('Alan izinleri yüklenirken bir hata oluştu.');
            setFieldPermissions([]); // Reset permissions on error
        }
    };

    // Fetch Call Form States and Generate Dynamic Transitions
    useEffect(() => {
        const fetchAndProcessStates = async () => {
            setLoadingStates(true);
            let fetchedStates = {};
            try {
                // --- Token Ekleme Başlangıç ---
                const accessToken = localStorage.getItem('accessToken'); // 'accessToken' olarak güncellendi
                if (!accessToken) {
                    console.error('Authorization token not found for fetching states!');
                    toast.error('Yetkilendirme hatası: Token bulunamadı.');
                    setLoadingStates(false);
                    setDynamicCallFormStates({});
                    setDynamicStateTransitions({});
                    return;
                }
                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                };
                // --- Token Ekleme Bitiş ---

                const response = await axios.get(callFormStateApiUrl, { headers }); // <-- Header'ları ekle
                if (response.data && response.data.isSuccess && response.data.data?.items) {
                    fetchedStates = response.data.data.items.reduce((acc, state) => {
                        if (state.title && state.id) {
                            acc[state.title] = state.id;
                        }
                        return acc;
                    }, {});
                    setDynamicCallFormStates(fetchedStates);
                    console.log('Dynamic Call Form States loaded:', fetchedStates);

                    // ... (state transition logic remains the same) ...
                    const baseTransitionsStructure = {
                        'Taslak': { 'save': 'Eksper Onay Bekleniyor', 'draft': 'Taslak' },
                        'Yeni Çağrı Formu': { 'save': 'Eksper Onay Bekleniyor', 'draft': 'Taslak' },
                        'Eksper Onay Bekleniyor': { 'approve': 'Yönetici Onay Bekleniyor', 'reject': 'Çağrı Formu Reddedildi', 'return': 'Düzeltme Bekleniyor' },
                        'Yönetici Onay Bekleniyor': { 'approve': 'Ödeme Bekleniyor', 'reject': 'Çağrı Formu Reddedildi', 'return': 'Düzeltme Bekleniyor' },
                        'Ödeme Bekleniyor': { 'complete': 'Vekalet Bekleniyor', 'correction': 'Düzeltme Bekleniyor', 'reject': 'Müvekkil Reddedildi', 'addExpense': 'Ödeme Bekleniyor' },
                        'Vekalet Bekleniyor': { 'received': 'Evrak Bekleniyor', 'pending': 'Vekalet Bekleniyor' },
                        'Evrak Bekleniyor': { 'received': 'Eksper İşlem Bekleniyor', 'pending': 'Evrak Bekleniyor' },
                        'Eksper İşlem Bekleniyor': { 'next': 'Eksper Rapor Bekleniyor', 'pending': 'Eksper İşlem Bekleniyor' },
                        'Eksper Rapor Bekleniyor': { 'next': 'Eksper Raporu Ödeme Bekleniyor', 'pending': 'Eksper Rapor Bekleniyor' },
                        'Eksper Raporu Ödeme Bekleniyor': { 'next': 'Sigorta Başvuru Dilekçe Bekleniyor', 'pending': 'Eksper Raporu Ödeme Bekleniyor', 'addExpense': 'Eksper Raporu Ödeme Bekleniyor' },
                        'Sigorta Başvuru Dilekçe Bekleniyor': { 'pending': 'Sigorta Başvuru Dilekçe Bekleniyor' },
                        'Düzeltme Bekleniyor': { 'update': 'Eksper Onay Bekleniyor', 'expertApproval': 'Eksper Onay Bekleniyor', 'managerApproval': 'Yönetici Onay Bekleniyor' },
                        'Tüm Form': { 'save': 'Tüm Form' }
                    };

                    const generatedTransitions = {};
                    for (const currentStateName in baseTransitionsStructure) {
                        if (fetchedStates[currentStateName]) {
                            generatedTransitions[currentStateName] = {};
                            for (const action in baseTransitionsStructure[currentStateName]) {
                                const nextStateName = baseTransitionsStructure[currentStateName][action];
                                const nextStateId = fetchedStates[nextStateName];
                                if (nextStateId !== undefined) {
                                    generatedTransitions[currentStateName][action] = nextStateId;
                                } else {
                                    console.warn(`State ID for '${nextStateName}' (target of ${currentStateName} -> ${action}) not found. Transition omitted.`);
                                }
                            }
                        } else {
                            console.warn(`State '${currentStateName}' from base structure key not found. Transitions omitted.`);
                        }
                    }
                    setDynamicStateTransitions(generatedTransitions);
                    console.log('IMMEDIATE CHECK - Dynamic State Transitions set to:', generatedTransitions);


                } else {
                    console.error('Failed to fetch or parse call form states:', response.data);
                    toast.error('Çağrı formu durumları yüklenemedi.');
                    setDynamicCallFormStates({});
                    setDynamicStateTransitions({});
                }
            } catch (error) {
                console.error('Error fetching call form states:', error);
                toast.error('Çağrı formu durumları yüklenirken bir hata oluştu.');
                setDynamicCallFormStates({});
                setDynamicStateTransitions({});
            } finally {
                setLoadingStates(false);
            }
        };
        fetchAndProcessStates();
    }, [callFormStateApiUrl]);

    // Fetch permissions for new form (Depends on dynamicCallFormStates)
    useEffect(() => {
        // Only run if it's a new form AND dynamic states are loaded
        if (!id && dynamicCallFormStates && !loadingStates) {
            const initialStateTitle = 'Yeni Çağrı Formu';
            const initialStateId = dynamicCallFormStates[initialStateTitle];
            if (initialStateId) {
                fetchFieldPermissions(initialStateId);
                setCurrentFormState(initialStateTitle);
            } else {
                console.warn(`State ID for '${initialStateTitle}' not found in fetched callFormStates.`);
                setFieldPermissions([]);
                setCurrentFormState(initialStateTitle);
            }
        }
    }, [id, dynamicCallFormStates, loadingStates]);

    useEffect(() => {
        const fetchInsuranceCompanies = async () => {
            try {
                const response = await fetchFormData({
                    apiEndpoint: insuranceCompanyApiUrl,
                    page: 1,
                    pageSize: 100, // Fetch all insurance companies for dropdown
                    search: null,
                });

                console.log('Insurance companies API response:', response);

                // Handle different possible response structures
                if (response && response.isSuccess && response.data && Array.isArray(response.data.items)) {
                    // Structure: {isSuccess: true, data: {items: [...]}}
                    const formattedCompanies = response.data.items.map(company => ({
                        id: company.id,
                        name: company.name,
                        address: company.address,
                        phoneNumber: company.phoneNumber,
                        email: company.email,
                        contactPerson: company.contactPerson,
                        website: company.website,
                        taxNumber: company.taxNumber,
                        ibanNumber: company.ibanNumber
                    }));
                    setInsuranceCompanies(formattedCompanies);
                    console.log('Sigorta şirketleri yüklendi:', formattedCompanies);
                }
                // Handle other common response structure
                else if (response && response.items && Array.isArray(response.items)) {
                    // Structure: {items: [...]}
                    const formattedCompanies = response.items.map(company => ({
                        id: company.id,
                        name: company.name,
                        address: company.address,
                        phoneNumber: company.phoneNumber,
                        email: company.email,
                        contactPerson: company.contactPerson,
                        website: company.website,
                        taxNumber: company.taxNumber,
                        ibanNumber: company.ibanNumber
                    }));
                    setInsuranceCompanies(formattedCompanies);
                    console.log('Sigorta şirketleri yüklendi:', formattedCompanies);
                }
                // Direct data array
                else if (Array.isArray(response)) {
                    // Structure: [...]
                    const formattedCompanies = response.map(company => ({
                        id: company.id,
                        name: company.name || company.title,
                        address: company.address,
                        phoneNumber: company.phoneNumber || company.phone,
                        email: company.email,
                        contactPerson: company.contactPerson,
                        website: company.website,
                        taxNumber: company.taxNumber,
                        ibanNumber: company.ibanNumber
                    }));
                    setInsuranceCompanies(formattedCompanies);
                    console.log('Sigorta şirketleri yüklendi:', formattedCompanies);
                }
                // Direct data object with data property
                else if (response && response.data && Array.isArray(response.data)) {
                    // Structure: {data: [...]}
                    const formattedCompanies = response.data.map(company => ({
                        id: company.id,
                        name: company.name || company.title,
                        address: company.address,
                        phoneNumber: company.phoneNumber || company.phone,
                        email: company.email,
                        contactPerson: company.contactPerson,
                        website: company.website,
                        taxNumber: company.taxNumber,
                        ibanNumber: company.ibanNumber
                    }));
                    setInsuranceCompanies(formattedCompanies);
                    console.log('Sigorta şirketleri yüklendi:', formattedCompanies);
                }
                else {
                    console.error('Unexpected insurance companies data structure:', response);
                    toast.error('Sigorta şirketleri beklenmedik bir formatta döndü.');
                }
            } catch (error) {
                console.error('Error fetching insurance companies:', error);
                toast.error('Sigorta şirketleri yüklenirken bir hata oluştu.');
            }
        };

        fetchInsuranceCompanies();
    }, [insuranceCompanyApiUrl]);

    // Add new useEffect to fetch work file types
    useEffect(() => {
        const fetchWorkFileTypes = async () => {
            try {
                const response = await fetchFormData({
                    apiEndpoint: workFileTypeApiUrl,
                    page: 1,
                    pageSize: 100, // Fetch all work file types for dropdown
                    search: null,
                });

                console.log('Work file types API response:', response);

                // Handle different possible response structures
                if (response && response.isSuccess && response.data && Array.isArray(response.data.items)) {
                    // Structure: {isSuccess: true, data: {items: [...]}}
                    const formattedWorkFileTypes = response.data.items.map(fileType => ({
                        id: fileType.id,
                        title: fileType.title || fileType.name,
                        description: fileType.description,
                        // Include any other properties needed
                    }));
                    setWorkFileTypes(formattedWorkFileTypes);
                    console.log('İş dosya türleri yüklendi:', formattedWorkFileTypes);
                }
                // Handle other common response structure
                else if (response && response.items && Array.isArray(response.items)) {
                    // Structure: {items: [...]}
                    const formattedWorkFileTypes = response.items.map(fileType => ({
                        id: fileType.id,
                        title: fileType.title || fileType.name,
                        description: fileType.description,
                    }));
                    setWorkFileTypes(formattedWorkFileTypes);
                    console.log('İş dosya türleri yüklendi:', formattedWorkFileTypes);
                }
                // Direct data array
                else if (Array.isArray(response)) {
                    // Structure: [...]
                    const formattedWorkFileTypes = response.map(fileType => ({
                        id: fileType.id,
                        title: fileType.title || fileType.name,
                        description: fileType.description,
                    }));
                    setWorkFileTypes(formattedWorkFileTypes);
                    console.log('İş dosya türleri yüklendi:', formattedWorkFileTypes);
                }
                // Direct data object with data property
                else if (response && response.data && Array.isArray(response.data)) {
                    // Structure: {data: [...]}
                    const formattedWorkFileTypes = response.data.map(fileType => ({
                        id: fileType.id,
                        title: fileType.title || fileType.name,
                        description: fileType.description,
                    }));
                    setWorkFileTypes(formattedWorkFileTypes);
                    console.log('İş dosya türleri yüklendi:', formattedWorkFileTypes);
                }
                else {
                    // Just log the error and show a message instead of setting fallback values
                    console.error('Unexpected work file types data structure:', response);
                    toast.error('İş dosya türleri beklenmedik bir formatta döndü.');
                    setWorkFileTypes([]); // Set empty array instead of fallback values
                }
            } catch (error) {
                // Just log the error and show a message instead of setting fallback values
                console.error('Error fetching work file types:', error);
                toast.error('İş dosya türleri yüklenirken bir hata oluştu.');
                setWorkFileTypes([]); // Set empty array instead of fallback values
            }
        };

        fetchWorkFileTypes();
    }, [workFileTypeApiUrl]);

    // Add useEffect to fetch cities using the provided pattern
    useEffect(() => {
        const fetchCities = async () => {
            try {
                const response = await fetchFormData({
                    apiEndpoint: cityApiUrl,
                    page: 1,
                    pageSize: 100
                });

                // Handle both API response formats
                if (response?.isSuccess && response?.data?.items) {
                    setCities(response.data.items);
                } else if (response?.items) {
                    setCities(response.items);
                } else if (Array.isArray(response)) {
                    setCities(response);
                } else {
                    setCities([]);
                }
            } catch (error) {
                console.error('Error fetching cities:', error);
                toast.error('Şehirler alınırken hata oluştu.');
            }
        };
        fetchCities();
    }, [cityApiUrl]);

    // Add useEffect to fetch districts using the provided pattern
    useEffect(() => {
        const fetchDistricts = async () => {
            if (formData.city) {
                try {
                    const response = await fetchFormData({
                        apiEndpoint: `${districtApiUrl}?city=${formData.city}`,
                        page: 1,
                        pageSize: 100
                    });

                    // Handle both API response formats
                    if (response?.isSuccess && response?.data?.items) {
                        setDistricts(response.data.items);

                        // Filter districts for the selected city
                        const cityDistricts = response.data.items;
                        setFilteredDistricts(cityDistricts);
                    } else if (response?.items) {
                        setDistricts(response.items);
                        setFilteredDistricts(response.items);
                    } else if (Array.isArray(response)) {
                        setDistricts(response);
                        setFilteredDistricts(response);
                    } else {
                        setDistricts([]);
                        setFilteredDistricts([]);
                    }
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    toast.error('İlçeler alınırken hata oluştu.');
                }
            } else {
                setDistricts([]);
                setFilteredDistricts([]);
            }
        };
        fetchDistricts();
    }, [formData.city, districtApiUrl]);

    // Simplified handleCityChange function
    const handleCityChange = (cityId) => {
        console.log('City selected with ID:', cityId);

        // Update the formData with the selected city
        setFormData(prev => ({
            ...prev,
            city: cityId || null,
            // Reset district when city changes
            district: null
        }));

        // Districts will be fetched by the useEffect that watches formData.city
    };    // Add monitoring for city and district data
    useEffect(() => {
        console.log('Cities state updated:', cities);
        console.log('Districts state updated:', districts);
        console.log('Filtered districts state updated:', filteredDistricts);
    }, [cities, districts, filteredDistricts]);    // Handle license plate data from navigation state
    useEffect(() => {
        if (location.state?.fromLicensePlate && location.state?.customerId && location.state?.licensePlateId && !id) {
            console.log('Creating new form from license plate:', {
                customerId: location.state.customerId,
                licensePlateId: location.state.licensePlateId
            });

            const fetchLicensePlateAndCustomerData = async () => {
                try {
                    // Fetch license plate data
                    const licensePlateResponse = await fetchFormData({
                        apiEndpoint: `${licensePlateApiUrl}/${location.state.licensePlateId}`,
                        page: 1,
                        pageSize: 1
                    });

                    // Fetch customer data
                    const customerResponse = await fetchFormData({
                        apiEndpoint: `${customerApiUrl}/${location.state.customerId}`,
                        page: 1,
                        pageSize: 1
                    });

                    let licensePlateData = null;
                    let customerData = null;

                    // Process license plate response
                    if (licensePlateResponse?.isSuccess && licensePlateResponse?.data) {
                        licensePlateData = licensePlateResponse.data;
                    } else if (licensePlateResponse?.data) {
                        licensePlateData = licensePlateResponse.data;
                    } else if (licensePlateResponse) {
                        licensePlateData = licensePlateResponse;
                    }

                    // Process customer response
                    if (customerResponse?.isSuccess && customerResponse?.data) {
                        customerData = customerResponse.data;
                    } else if (customerResponse?.data) {
                        customerData = customerResponse.data;
                    } else if (customerResponse) {
                        customerData = customerResponse;
                    }

                    console.log('Fetched license plate data:', licensePlateData);
                    console.log('Fetched customer data:', customerData);

                    if (licensePlateData || customerData) {
                        setFormData(prev => ({
                            ...prev,

                            // Customer Info
                            ...(customerData && {
                                customerId: customerData.id || location.state.customerId,
                                clientName: customerData.customerType === 'Bireysel' ? (customerData.clientName || null) : null,
                                companyName: customerData.customerType === 'Kurumsal' ? (customerData.companyName || null) : null,
                                tcid: customerData.customerType === 'Bireysel' ? (customerData.identityNumber || null) : null,
                                crsNumber: customerData.customerType === 'Kurumsal' ? (customerData.crsNumber || null) : null,
                                taxNumber: customerData.customerType === 'Kurumsal' ? (customerData.taxNumber || null) : null,
                                customerType: customerData.customerType || 'Bireysel',
                                companyRepresentative: customerData.companyRepresentative || null,

                                // Contact Info from arrays
                                phoneNumber: customerData.phones?.[0]?.phone || null,
                                phoneDescription: customerData.phones?.[0]?.phoneDescription || null,
                                phoneNumber2: customerData.phones?.[1]?.phone || null,
                                phoneDescription2: customerData.phones?.[1]?.phoneDescription || null,
                                email: customerData.emails?.[0]?.email || null,
                                emailDescription: customerData.emails?.[0]?.emailDescription || null,
                                email2: customerData.emails?.[1]?.email || null,
                                emailDescription2: customerData.emails?.[1]?.emailDescription || null,
                                iban: customerData.ibans?.[0]?.iban || null,
                                ibanDescription: customerData.ibans?.[0]?.ibanDescription || null,
                                iban2: customerData.ibans?.[1]?.iban || null,
                                ibanDescription2: customerData.ibans?.[1]?.ibanDescription || null,

                                // Address Info
                                address: customerData.address || null,
                                city: customerData.district?.city?.id || null,
                                district: customerData.district?.id || null,

                                // Agent Info
                                recipientOfPowerOfAttorney: customerData.agent ? `${customerData.agent.firstName} ${customerData.agent.lastName}`.trim() : null,
                                agentId: customerData.agent?.id || null,

                                // Other customer fields
                                reference: customerData.reference || null,
                                middleman: customerData.middleman || null,
                                middlemanIban: customerData.middlemanIban || null,
                                hasContractArrived: customerData.contractOriginalArrived ? "yes" : "no",

                                // Contract/middleman info from customer
                                customerContractRate: customerData.customerContractRate !== undefined ? customerData.contractRate?.toString() : null,
                                customerIsMiddlemanContractBased: customerData.isMiddlemanContractBased === true,
                                customerMiddlemanContractRate: customerData.isMiddlemanContractBased === true ? (customerData.middlemanContractRate !== undefined ? customerData.middlemanContractRate?.toString() : null) : null,
                                customerMiddlemanContractPrice: customerData.isMiddlemanContractBased === false ? (customerData.middlemanContractPrice !== undefined ? customerData.middlemanContractPrice.toString() : null) : null,
                            }),

                            // License Plate Info
                            ...(licensePlateData && {
                                licensePlate: licensePlateData.licensePlateNumber || null,
                                chassisNumber: licensePlateData.carchassisNumber || null,
                                carBrand: licensePlateData.carBrand || null,
                                carModel: licensePlateData.carModel || null,
                                carYear: licensePlateData.carYear || null,
                                hasCarSoldBefore: licensePlateData.hasCarSoldBefore ? "yes" : "no",
                                isThereLovClaim: licensePlateData.isThereLovClaim ? "yes" : "no",
                                lovClaimAmount: licensePlateData.lovClaimAmount || null,
                                lpImpeachmentStatus: licensePlateData.lpImpeachmentStatus ? "yes" : "no",
                                lpImpeachmentAmount: licensePlateData.lpImpeachmentAmount || null,

                                // License plate specific contract/middleman fields
                                licensePlateCustomerContractRate: licensePlateData.customerContractRate !== undefined ? licensePlateData.customerContractRate?.toString() : null,
                                licensePlateIsMiddlemanContractBased: licensePlateData.isMiddlemanContractBased === true,
                                licensePlateMiddlemanContractRate: licensePlateData.isMiddlemanContractBased === true ? (licensePlateData.middlemanContractRate !== undefined ? licensePlateData.middlemanContractRate?.toString() : null) : null,
                                licensePlateMiddlemanContractPrice: licensePlateData.isMiddlemanContractBased === false ? (licensePlateData.middlemanContractPrice !== undefined ? licensePlateData.middlemanContractPrice?.toString() : null) : null,
                            }),

                            // Insurance Info from license plate
                            ...(licensePlateData && {
                                trafficInsurancePolicy: {
                                    trafficInsuranceProvider: licensePlateData.trafficInsurancePolicy?.trafficInsuranceProvider?.id
                                        ? [licensePlateData.trafficInsurancePolicy.trafficInsuranceProvider.id]
                                        : [],
                                    trafficInsuranceNumber: licensePlateData.trafficInsurancePolicy?.trafficInsuranceNumber || null,
                                    trafficInsuranceStart: licensePlateData.trafficInsurancePolicy?.trafficInsuranceStart
                                        ? new Date(licensePlateData.trafficInsurancePolicy.trafficInsuranceStart)
                                        : null,
                                    trafficInsuranceExpiry: licensePlateData.trafficInsurancePolicy?.trafficInsuranceExpiry
                                        ? new Date(licensePlateData.trafficInsurancePolicy.trafficInsuranceExpiry)
                                        : null
                                },
                                cascoInsurancePolicy: {
                                    cascoInsuranceProvider: licensePlateData.cascoInsurancePolicy?.cascoInsuranceProvider?.id
                                        ? [licensePlateData.cascoInsurancePolicy.cascoInsuranceProvider.id]
                                        : [],
                                    cascoInsuranceNumber: licensePlateData.cascoInsurancePolicy?.cascoInsuranceNumber || null,
                                    cascoInsuranceStart: licensePlateData.cascoInsurancePolicy?.cascoInsuranceStart
                                        ? new Date(licensePlateData.cascoInsurancePolicy.cascoInsuranceStart)
                                        : null,
                                    cascoInsuranceExpiry: licensePlateData.cascoInsurancePolicy?.cascoInsuranceExpiry
                                        ? new Date(licensePlateData.cascoInsurancePolicy.cascoInsuranceExpiry)
                                        : null
                                }
                            })
                        }));

                        // Set customer ID for other components
                        setCustomerId(location.state.customerId);

                        toast.success('Plaka ve müşteri bilgileri başarıyla yüklendi.');
                    } else {
                        toast.error('Plaka veya müşteri bilgileri alınamadı.');
                    }

                } catch (error) {
                    console.error('Error fetching license plate or customer data:', error);
                    toast.error('Veriler yüklenirken hata oluştu.');
                }
            };

            fetchLicensePlateAndCustomerData();

            // Clear the state to prevent re-loading on subsequent renders
            window.history.replaceState({}, document.title);
        }
    }, [location.state, id, customerApiUrl, licensePlateApiUrl]);

    // Fetch existing form data if editing an existing form
    useEffect(() => {
        console.log('[CallForm] useEffect for fetching existing form data triggered', { id, isNewFormFromDataPool });
        if (id) {
            if (isNewFormFromDataPool) {
                // Fetch from datapool API and populate the form
                const fetchDataPoolData = async () => {
                    try {
                        const datapoolApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/datapool';

                        // --- Token Ekleme Başlangıç ---
                        const accessToken = localStorage.getItem('accessToken'); // 'accessToken' olarak güncellendi
                        if (!accessToken) {
                            console.error('Authorization token not found for fetching datapool data!');
                            toast.error('Yetkilendirme hatası: Token bulunamadı.');
                            // Hata durumunda formu doldurmayı durdurabiliriz
                            return;
                        }
                        const headers = {
                            'Authorization': `Bearer ${accessToken}`,
                        };
                        // --- Token Ekleme Bitiş ---

                        // fetchFormData'nın headers kabul edip etmediğini kontrol edin.
                        // Eğer etmiyorsa, doğrudan axios kullanmanız gerekebilir.
                        // Şimdilik fetchFormData kullandığınızı varsayıyorum, ancak header ekleme yeteneği yoksa
                        // burayı axios.get ile değiştirmeniz gerekebilir.
                        const response = await fetchFormData({
                            apiEndpoint: `${datapoolApiUrl}/${id}`,
                            // headers: headers // fetchFormData bunu destekliyor mu? Kontrol edin.
                        });
                        // Eğer fetchFormData headers desteklemiyorsa, şöyle yapın:
                        /*
                        const response = await axios.get(`${datapoolApiUrl}/${id}`, { headers });
                        // response.data'yı uygun şekilde işleyin (fetchFormData'nın yaptığı gibi)
                        const processedResponse = response.data; // Veya response.data.data vs. API yapısına göre
                        */


                        if (response) {
                            populateFormWithDataPoolData(response);
                        }
                    } catch (error) {
                        console.error('Error fetching data from datapool:', error);
                        toast.error('Datapool veri çekme hatası!');
                    }
                };

                fetchDataPoolData();
            } else {
                // Existing logic for callform/{id}
                const fetchExistingFormData = async () => {
                    try {
                        // --- Token Ekleme Başlangıç ---
                        const accessToken = localStorage.getItem('accessToken'); // 'accessToken' olarak güncellendi
                        if (!accessToken) {
                            console.error('Authorization token not found for fetching existing call form data!');
                            toast.error('Yetkilendirme hatası: Token bulunamadı.');
                            // Form yüklemesini durdur
                            return;
                        }
                        const headers = {
                            'Authorization': `Bearer ${accessToken}`,
                        };
                        // --- Token Ekleme Bitiş ---

                        console.log('[CallForm] Making API call to fetch existing form data:', `${callformApiUrl}/${id}`);
                        const response = await axios.get(`${callformApiUrl}/${id}`, { headers }); // <-- Header'ları ekle

                        if (response.data && response.data.isSuccess) {
                            const apiData = response.data.data;
                            console.log('API verisi yüklendi:', apiData);

                            // Set canEdit from API response
                            setCanEdit(apiData.canEdit !== false); // Default to true if not explicitly false
                            console.log('canEdit value from API:', apiData.canEdit);

                            // ... (rest of the data processing logic remains the same) ...                            // Extract accidentFile ID - eğer birden fazla accidentFile varsa, hepsini tutabiliriz
                            if (apiData.accidentFiles && apiData.accidentFiles.length > 0) {
                                // İlk accident file ID'sini ana ID olarak tut (backwards compatibility için)
                                setAccidentFileId(apiData.accidentFiles[0].id);
                                console.log('AccidentFile ID extracted:', apiData.accidentFiles[0].id);
                                console.log('Total AccidentFiles count:', apiData.accidentFiles.length);
                            }

                            // Müşteri ID'sini çıkar
                            if (apiData.customers && apiData.customers.length > 0) {
                                setCustomerId(apiData.customers[0].id);
                                console.log('Customer ID extracted:', apiData.customers[0].id);
                            } else if (apiData.customer && apiData.customer.length > 0) {
                                setCustomerId(apiData.customer[0]);
                                console.log('Customer ID extracted:', apiData.customer[0]);
                            }

                            // PowerOfAttorney ID'sini çıkar
                            if (apiData.powerOfAttorneys && apiData.powerOfAttorneys.length > 0) {
                                setPowerOfAttorneyId(apiData.powerOfAttorneys[0].id);
                                console.log('PowerOfAttorney ID extracted:', apiData.powerOfAttorneys[0].id);
                            }

                            // Müşteri verilerini al (ilk müşteriyi kullanıyoruz)
                            const customer = apiData.customers && apiData.customers.length > 0
                                ? apiData.customers[0]
                                : null;

                            // Plaka verilerini al
                            const licensePlate = apiData.licensePlates && apiData.licensePlates.length > 0
                                ? apiData.licensePlates[0]
                                : null;

                            // Kaza verilerini al
                            const accident = apiData.accidents && apiData.accidents.length > 0
                                ? apiData.accidents[0]
                                : null;                            // Dosya verilerini al - tüm accidentFiles'ı işle
                            const accidentFiles = apiData.accidentFiles || [];
                            setAccidentFiles(accidentFiles); // Store accidentFiles in state
                            const accidentFile = accidentFiles.length > 0 ? accidentFiles[0] : null; // İlk dosya backwards compatibility için

                            // Her accidentFile için ayrı bir entry oluştur - hiçbir şeyi toplama
                            const allFilesToBeWorked = accidentFiles.map((af) => {
                                // Bu accidentFile'ın filesToBeWorked verilerini olduğu gibi kullan
                                const filesToBeWorked = af.filesToBeWorked || [];
                                
                                // Her filesToBeWorked objesini işle
                                const processedFiles = filesToBeWorked.map(file => ({
                                    fileType: file.fileType ? file.fileType.map(ft => ft.id) : [],
                                    _fileTypeTitles: file.fileType ? file.fileType.map(ft => ft.title) : [],
                                    fileExpense: file.fileExpense || 0,
                                    numberOfDays: file.numberOfDays || 0,
                                    expensePerDay: file.expensePerDay || 0
                                }));

                                return {
                                    filesToBeWorked: processedFiles, // Tüm filesToBeWorked objelerini sakla
                                    // AccidentFile seviyesindeki özellikler
                                    withReport: af.withReport || false,
                                    withFault: af.withFault || false,
                                    withoutReport: af.withoutReport || false,
                                    accidentFileId: af.id,
                                    fileNumber: af.fileNumber,
                                    // Sigorta başvuru bilgilerini ekle
                                    insuranceApplicationType: af.insuranceApplicationType || null,
                                    insuranceApplicationDate: af.insuranceApplicationDate || null,
                                    readyForArbitration: af.readyForArbitration || false
                                };
                            });

                            // Vekalet verilerini al
                            const powerOfAttorney = apiData.powerOfAttorneys && apiData.powerOfAttorneys.length > 0
                                ? apiData.powerOfAttorneys[0]
                                : null;

                            // Extract existing comments if available
                            const comments = apiData.comments || [];
                            setExistingComments(comments);

                            // Extract existing files if available
                            // Extract existing files if available
                            if (apiData.files && apiData.files.length > 0) {
                                console.log('Existing files found:', apiData.files);
                                // Files are handled by FilesComponent, no need to store in state
                            }
                            // Raw district data from API response
                            console.log('Raw customer district from API:', customer?.district);

                            // Extract city and district IDs from the API response
                            const districtId = customer?.district?.id || null;
                            const cityId = customer?.district?.city?.id || null;


                            // --- Determine the form state and Fetch Permissions ---
                            let determinedStateId = null;
                            let determinedStateName = 'Tüm Form'; // Default if not found

                            // Correctly access the ID and Title from the callFormState object
                            if (apiData.callFormState && typeof apiData.callFormState === 'object' && apiData.callFormState.id) {
                                determinedStateId = apiData.callFormState.id;
                                determinedStateName = apiData.callFormState.title || 'Durum Başlığı Yok';
                            } else {
                                console.warn("No valid callFormState object with ID found in API data for existing form. Defaulting permissions fetch for 'Tüm Form'.");
                                // Attempt to get ID for 'Tüm Form' if available (using dynamic states *if* loaded and available)
                                if (dynamicCallFormStates && dynamicCallFormStates['Tüm Form']) {
                                    determinedStateId = dynamicCallFormStates['Tüm Form'];
                                } else {
                                    // Fallback if dynamic states not loaded or 'Tüm Form' missing
                                    determinedStateId = null; // Fetch permissions might fail or use default
                                }
                                determinedStateName = 'Tüm Form';
                            }

                            console.log(`Determined State - ID: ${determinedStateId}, Name: ${determinedStateName}`);

                            // Only fetch permissions if canEdit is true
                            if (apiData.canEdit !== false) {
                                // Fetch permissions using the determined state ID *before* setting form data
                                // Ensure states are loaded before fetching permissions if we need fallback ID
                                if (!determinedStateId && loadingStates) {
                                    console.log("Waiting for dynamic states to load for potential fallback permission fetch...");
                                } else {
                                    await fetchFieldPermissions(determinedStateId); // fetchFieldPermissions already handles token
                                }
                            } else {
                                console.log("canEdit is false, skipping field permissions fetch");
                                setFieldPermissions([]); // Set empty permissions for read-only mode
                            }

                            // Update the state name *after* fetching permissions
                            setCurrentFormState(determinedStateName);

                            // ... (rest of the data formatting logic) ...
                            // Format the data from the API - keep original date formats for display
                            const formattedData = {
                                // Müşteri Bilgileri
                                customers: customer ? [
                                    {
                                        ...customer,
                                        created: customer.created ? new Date(customer.created) : null
                                    }
                                ] : [],
                                clientName: customer?.clientName || null,
                                companyName: customer?.companyName || null,
                                companyRepresentative: customer?.companyRepresentative || null,
                                customerType: customer?.customerType || 'Bireysel',
                                tcid: customer?.identityNumber || null,
                                taxNumber: customer?.taxNumber || null,
                                crsNumber: customer?.crsNumber || null,
                                recipientOfPowerOfAttorney: customer?.agent ? 
                                    `${customer.agent.firstName || ''} ${customer.agent.lastName || ''}`.trim() : null,
                                agentId: customer?.agent?.id || null,
                                reference: customer?.reference || null,

                                // İletişim Bilgileri
                                phoneNumber: customer?.phones && customer.phones.length > 0
                                    ? customer.phones[0].phone
                                    : null,
                                phoneDescription: customer?.phones && customer.phones.length > 0
                                    ? customer.phones[0].phoneDescription
                                    : null,
                                phoneNumber2: customer?.phones && customer.phones.length > 1
                                    ? customer.phones[1].phone
                                    : null,
                                phoneDescription2: customer?.phones && customer.phones.length > 1
                                    ? customer.phones[1].phoneDescription
                                    : null,
                                email: customer?.emails && customer.emails.length > 0
                                    ? customer.emails[0].email
                                    : null,
                                emailDescription: customer?.emails && customer.emails.length > 0
                                    ? customer.emails[0].emailDescription
                                    : null,
                                email2: customer?.emails && customer.emails.length > 1
                                    ? customer.emails[1].email
                                    : null,
                                emailDescription2: customer?.emails && customer.emails.length > 1
                                    ? customer.emails[1].emailDescription
                                    : null,
                                iban: customer?.ibans && customer.ibans.length > 0
                                    ? customer.ibans[0].iban
                                    : null,
                                ibanDescription: customer?.ibans && customer.ibans.length > 0
                                    ? customer.ibans[0].ibanDescription
                                    : null,
                                iban2: customer?.ibans && customer.ibans.length > 1
                                    ? customer.ibans[1].iban
                                    : null,
                                ibanDescription2: customer?.ibans && customer.ibans.length > 1
                                    ? customer.ibans[1].ibanDescription
                                    : null,

                                // Aracı Bilgileri - API'den doğru alanları al
                                middleman: customer?.middleman || null,
                                middlemanIban: customer?.middlemanIban || null,
                                // Customer specific contract/middleman
                                customerContractRate: customer?.contractRate !== undefined ? customer.contractRate?.toString() : null,
                                customerIsMiddlemanContractBased: customer?.isMiddlemanContractBased === true,
                                customerMiddlemanContractRate: customer?.isMiddlemanContractBased === true ? (customer?.middlemanContractRate !== undefined ? customer.middlemanContractRate?.toString() : null) : null,
                                customerMiddlemanContractPrice: customer?.isMiddlemanContractBased === false ? (customer?.middlemanContractPrice !== undefined ? customer.middlemanContractPrice?.toString() : null) : null,

                                // Adres Bilgileri
                                address: customer?.address || null,

                                // Set city and district from the API response
                                city: cityId,
                                district: districtId, // This will trigger district fetching useEffect

                                // Araç Bilgileri
                                licensePlate: licensePlate?.licensePlateNumber || null,
                                chassisNumber: licensePlate?.carchassisNumber || null,
                                carBrand: licensePlate?.carBrand || null,
                                carModel: licensePlate?.carModel || null,
                                carYear: licensePlate?.carYear || null,
                                hasCarSoldBefore: licensePlate?.hasCarSoldBefore ? "yes" : "no",
                                isThereLovClaim: licensePlate?.isThereLovClaim ? "yes" : "no",
                                lovClaimAmount: licensePlate?.lovClaimAmount || null,
                                lpImpeachmentStatus: licensePlate?.lpImpeachmentStatus || licensePlate?.lpImpeachmentStatus === true ? "yes" : "no",
                                lpImpeachmentAmount: licensePlate?.lpImpeachmentAmount || null,
                                // LicensePlate specific contract/middleman
                                licensePlateCustomerContractRate: customer?.contractRate !== undefined ? customer.contractRate?.toString() : null,
                                licensePlateIsMiddlemanContractBased: licensePlate?.isMiddlemanContractBased === true,
                                licensePlateMiddlemanContractRate: licensePlate?.isMiddlemanContractBased === true ? (licensePlate?.middlemanContractRate !== undefined ? licensePlate.middlemanContractRate?.toString() : null) : null,
                                licensePlateMiddlemanContractPrice: licensePlate?.isMiddlemanContractBased === false ? (licensePlate?.middlemanContractPrice !== undefined ? licensePlate.middlemanContractPrice?.toString() : null) : null,

                                // Sigorta Bilgileri - from licensePlates
                                trafficInsurancePolicy: {
                                    trafficInsuranceProvider: licensePlate?.trafficInsurancePolicy?.trafficInsuranceProvider
                                        ? (typeof licensePlate.trafficInsurancePolicy.trafficInsuranceProvider === 'object' && !Array.isArray(licensePlate.trafficInsurancePolicy.trafficInsuranceProvider)
                                            ? [licensePlate.trafficInsurancePolicy.trafficInsuranceProvider.id]
                                            : licensePlate.trafficInsurancePolicy.trafficInsuranceProvider)
                                        : [],
                                    trafficInsuranceNumber: licensePlate?.trafficInsurancePolicy?.trafficInsuranceNumber || null,
                                    trafficInsuranceStart: licensePlate?.trafficInsurancePolicy?.trafficInsuranceStart
                                        ? new Date(licensePlate.trafficInsurancePolicy.trafficInsuranceStart)
                                        : null,
                                    trafficInsuranceExpiry: licensePlate?.trafficInsurancePolicy?.trafficInsuranceExpiry
                                        ? new Date(licensePlate.trafficInsurancePolicy.trafficInsuranceExpiry)
                                        : null
                                },

                                cascoInsurancePolicy: {
                                    cascoInsuranceProvider: licensePlate?.cascoInsurancePolicy?.cascoInsuranceProvider
                                        ? (typeof licensePlate.cascoInsurancePolicy.cascoInsuranceProvider === 'object' && !Array.isArray(licensePlate.cascoInsurancePolicy.cascoInsuranceProvider)
                                            ? [licensePlate.cascoInsurancePolicy.cascoInsuranceProvider.id]
                                            : licensePlate.cascoInsurancePolicy.cascoInsuranceProvider)
                                        : [],
                                    cascoInsuranceNumber: licensePlate?.cascoInsurancePolicy?.cascoInsuranceNumber || null,
                                    cascoInsuranceStart: licensePlate?.cascoInsurancePolicy?.cascoInsuranceStart
                                        ? new Date(licensePlate.cascoInsurancePolicy.cascoInsuranceStart)
                                        : null,
                                    cascoInsuranceExpiry: licensePlate?.cascoInsurancePolicy?.cascoInsuranceExpiry
                                        ? new Date(licensePlate.cascoInsurancePolicy.cascoInsuranceExpiry)
                                        : null
                                },

                                // Kaza Bilgileri
                                accidentDate: accident?.accidentDate
                                    ? new Date(accident.accidentDate)
                                    : null,
                                isTrialDocument: accident?.isTrialDocument ? "yes" : "no",
                                isWorkDocument: accident?.isWorkDocument ? "yes" : "no",  // Changed from willLorBeWorked
                                bonusEligibility: accident?.bonusEligibility?.toString() || null,
                                shouldPayNotaryFee: accident?.shouldPayNotaryFee ? "yes" : "no",
                                notaryFeeAmount: accident?.notaryFeeAmount?.toString() || null,
                                estimatedDepreciationAmount: accident?.estimatedDepreciationAmount?.toString() || null,
                                damageAmount: accident?.damageAmount?.toString() || null,
                                damageDifferenceAmount: accident?.damageDifferenceAmount?.toString() || null,
                                lorAmount: accident?.loRamount?.toString() || null,

                                // Karşı Taraf Bilgileri
                                counterpartyType: accident?.counterpartyType || 'Bireysel',
                                counterpartyIdentificationNumber: accident?.counterpartyIdentificationNumber || null,
                                counterpartyTaxNumber: accident?.counterpartyTaxNumber || null,
                                counterpartyCarOwner: accident?.counterpartyCarOwner || null,
                                counterpartyLicensePlateNumber: accident?.counterpartyLicensePlateNumber || null,
                                counterpartyAddress: accident?.counterpartyAddress || null,

                                // Karşı Taraf Sigorta Bilgileri - from accidents
                                counterpartyTrafficInsurancePolicy: {
                                    trafficInsuranceProvider: accident?.counterpartyTrafficInsurancePolicy?.trafficInsuranceProvider
                                        ? (typeof accident.counterpartyTrafficInsurancePolicy.trafficInsuranceProvider === 'object' && !Array.isArray(accident.counterpartyTrafficInsurancePolicy.trafficInsuranceProvider)
                                            ? [accident.counterpartyTrafficInsurancePolicy.trafficInsuranceProvider.id]
                                            : accident.counterpartyTrafficInsurancePolicy.trafficInsuranceProvider)
                                        : [],
                                    trafficInsuranceNumber: accident?.counterpartyTrafficInsurancePolicy?.trafficInsuranceNumber || null,
                                    trafficInsuranceStart: accident?.counterpartyTrafficInsurancePolicy?.trafficInsuranceStart
                                        ? new Date(accident.counterpartyTrafficInsurancePolicy.trafficInsuranceStart)
                                        : null,
                                    trafficInsuranceExpiry: accident?.counterpartyTrafficInsurancePolicy?.trafficInsuranceExpiry
                                        ? new Date(accident.counterpartyTrafficInsurancePolicy.trafficInsuranceExpiry)
                                        : null
                                },

                                counterpartyCascoInsurancePolicy: {
                                    cascoInsuranceProvider: accident?.counterpartyCascoInsurancePolicy?.cascoInsuranceProvider
                                        ? (typeof accident.counterpartyCascoInsurancePolicy.cascoInsuranceProvider === 'object' && !Array.isArray(accident.counterpartyCascoInsurancePolicy.cascoInsuranceProvider)
                                            ? [accident.counterpartyCascoInsurancePolicy.cascoInsuranceProvider.id]
                                            : accident.counterpartyCascoInsurancePolicy.cascoInsuranceProvider)
                                        : [],
                                    cascoInsuranceNumber: accident?.counterpartyCascoInsurancePolicy?.cascoInsuranceNumber || null,
                                    cascoInsuranceStart: accident?.counterpartyCascoInsurancePolicy?.cascoInsuranceStart
                                        ? new Date(accident.counterpartyCascoInsurancePolicy.cascoInsuranceStart)
                                        : null,
                                    cascoInsuranceExpiry: accident?.counterpartyCascoInsurancePolicy?.cascoInsuranceExpiry
                                        ? new Date(accident.counterpartyCascoInsurancePolicy.cascoInsuranceExpiry)
                                        : null
                                },

                                // Kusurluluk Oranları - from accidents
                                ourFaultRate: accident?.ourFaultRate?.toString() || null,
                                counterpartyFaultRate: accident?.counterPartyFaultRate?.toString() || null,

                                // Vekalet Bilgileri
                                powerOfAttorneyNumber: powerOfAttorney?.poaNumber || null,
                                powerOfAttorneyDate: powerOfAttorney?.poaDate
                                    ? new Date(powerOfAttorney.poaDate)
                                    : null,
                                isPowerOfAttorneyTimed: powerOfAttorney?.isPoaTimeLimited ? "yes" : "no",
                                powerOfAttorneyEndDate: powerOfAttorney?.poaEndDate
                                    ? new Date(powerOfAttorney.poaEndDate)
                                    : null,
                                notaryNumber: powerOfAttorney?.notaryOfPoa || null,
                                isLicensePlatesLimited: powerOfAttorney?.isLicensePlatesLimited ? "yes" : "no",
                                plateLimit: powerOfAttorney?.licensePlateLimit || [],
                                isAccidentDateLimited: powerOfAttorney?.isAccidentDateLimited ? "yes" : "no",
                                plateLimitAccidentDate: powerOfAttorney?.licensePlateLimitAccidentDate
                                    ? new Date(powerOfAttorney.licensePlateLimitAccidentDate)
                                    : null,
                                hasOriginalArrived: powerOfAttorney?.poaOriginalArrived ? "yes" : "no",
                                contractRate: powerOfAttorney?.contractRate !== undefined ? powerOfAttorney.contractRate : (customer?.contractRate || null),

                                // License Plate'den alınan alanlar
                                // Açık Hasar Dosyası Var Mı - LicensePlate'den
                                isThereOpenDamageFile: licensePlate?.isThereOpenDamageFile ? "yes" : "no",

                                // Dosya Bilgileri
                                registrationDate: accidentFile?.fileOpenDate
                                    ? new Date(accidentFile.fileOpenDate)
                                    : null,
                                jobToBeWorked: accidentFile?.jobToBeWorked
                                    ? (Array.isArray(accidentFile.jobToBeWorked)
                                        ? accidentFile.jobToBeWorked // If it's already an array, use it
                                        : (typeof accidentFile.jobToBeWorked === 'object' && accidentFile.jobToBeWorked.id
                                            ? [accidentFile.jobToBeWorked.id] // If it's an object, extract the ID
                                            : [accidentFile.jobToBeWorked])) // If it's a string, wrap it in an array
                                    : null,
                                whoseInsurance: accidentFile?.whoseInsurance || null,
                                // Evrak Talep ve Gelme Tarihleri - Accident'den
                                documentRequestDate: accident?.documentRequestDate
                                    ? new Date(accident.documentRequestDate)
                                    : null,
                                documentRequestStatus: accidentFile?.documentRequestStatus || null,
                                documentReceivedDate: accident?.documentReceivedDate
                                    ? new Date(accident.documentReceivedDate)
                                    : null,                                // Dosya Türleri - tüm accidentFiles'lardan toplanan dosyalar
                                filesToBeWorked: allFilesToBeWorked,
                                
                                // AccidentFiles verilerini formData'ya ekle
                                accidentFiles: accidentFiles,

                                // Sözleşme bilgileri
                                hasContractArrived: customer?.contractOriginalArrived ? "yes" : "no",

                                // Yeni eklenen "isLorToBeWorked" alanı
                                willLorBeWorked: accident && accident.willLorBeWorked !== undefined ? accident.willLorBeWorked ? "yes" : "no" : "no",

                                // Expert review requirement field from API root level
                                needExpertReview: apiData.needExpertReview !== undefined ? apiData.needExpertReview : false,
                            };

                            // jobToBeWorked için özel işlem - Nesne veya ID dizisi olarak ayarla
                            if (accidentFile?.jobToBeWorked) {
                                if (typeof accidentFile.jobToBeWorked === 'object' && accidentFile.jobToBeWorked !== null && !Array.isArray(accidentFile.jobToBeWorked) && accidentFile.jobToBeWorked.id) {
                                    formattedData.jobToBeWorkedObject = accidentFile.jobToBeWorked; // Görüntüleme için nesneyi sakla
                                    formattedData.jobToBeWorked = [accidentFile.jobToBeWorked.id]; // API için ID dizisi
                                } else if (Array.isArray(accidentFile.jobToBeWorked)) {
                                    // Eğer zaten ID dizisi ise (veya nesne dizisi ise ID'leri çıkar)
                                    formattedData.jobToBeWorked = accidentFile.jobToBeWorked.map(job => (typeof job === 'object' && job !== null && job.id) ? job.id : job);
                                } else {
                                    // Tek bir ID ise diziye çevir
                                    formattedData.jobToBeWorked = [accidentFile.jobToBeWorked];
                                }
                            } else {
                                formattedData.jobToBeWorked = []; // Veya null, API beklentisine göre
                            }

                            // Form verilerini güncelle
                            setFormData(formattedData);

                            toast.success('Çağrı formu verileri başarıyla yüklendi.');


                        } else {
                            toast.error('Çağrı formu verileri alınamadı.');
                        }
                    } catch (error) {
                        console.error('Veri çekme hatası:', error);
                        toast.error('Çağrı formu verileri yüklenirken hata oluştu.');
                    }
                };

                fetchExistingFormData();
            }
        }
    }, [id, callformApiUrl, isNewFormFromDataPool]); // Dependencies optimized to prevent multiple calls

    // Update the populateFormWithDataPoolData function to match the actual data structure
    const populateFormWithDataPoolData = (response) => {
        // Set form state to "Yeni Çağrı Formu" for datapool forms
        setCurrentFormState('Yeni Çağrı Formu');

        // Ensure we're working with the data property from the response
        const datapoolData = response.data || response;

        // This function maps datapool API response to form fields
        const newFormData = { ...formData };

        // Customer Info - directly from data object
        newFormData.customerType = 'Bireysel'; // Assuming individual customer by default
        newFormData.clientName = datapoolData.fullName || '';
        newFormData.tcid = datapoolData.tcid || '';
        newFormData.reference = datapoolData.reference || ''; // Add reference mapping

        // License Plate and Accident Info
        newFormData.licensePlate = datapoolData.plate || '';
        newFormData.chassisNumber = datapoolData.chassisNumber || '';
        newFormData.accidentDate = datapoolData.accidentDate ? new Date(datapoolData.accidentDate) : null;

        // Contact Info - Phone numbers from array
        if (datapoolData.phone && Array.isArray(datapoolData.phone)) {
            if (datapoolData.phone.length > 0) {
                newFormData.phoneNumber = datapoolData.phone[0].phone || '';
                newFormData.phoneDescription = 'Ana Telefon'; // Default description
            }

            if (datapoolData.phone.length > 1) {
                newFormData.phoneNumber2 = datapoolData.phone[1].phone || '';
                newFormData.phoneDescription2 = 'Yedek Telefon'; // Default description
            }
        }

        // Agent info from creator field in API response instead of user object
        if (datapoolData.creator && datapoolData.creator.length > 0) {
            // Use the first creator in the array
            newFormData.recipientOfPowerOfAttorney = `${datapoolData.creator[0].firstName || ''} ${datapoolData.creator[0].lastName || ''}`.trim();
            newFormData.agentId = datapoolData.creator[0].id;
        } else if (datapoolData.user) {
            // Fallback to user if creator doesn't exist (backward compatibility)
            newFormData.recipientOfPowerOfAttorney = `${datapoolData.user.firstName || ''} ${datapoolData.user.lastName || ''}`.trim();
            newFormData.agentId = datapoolData.user.id;
        }

        // Fault status
        if (datapoolData.faultStatus !== undefined) {
            // Map fault status value to appropriate fields if needed
            if (datapoolData.faultStatus === 1) { // Assuming 1 means we're at fault
                newFormData.ourFaultRate = '100';
                newFormData.counterpartyFaultRate = '0';
            } else if (datapoolData.faultStatus === 0) { // Assuming 0 means counterparty is at fault
                newFormData.ourFaultRate = '0';
                newFormData.counterpartyFaultRate = '100';
            }
        }

        // Set the updated form data
        setFormData(newFormData);

        // Extract and set canEdit value from datapool response
        // The canEdit value is nested under data.canEdit in the datapool response
        if (datapoolData.canEdit !== undefined) {
            setCanEdit(datapoolData.canEdit !== false);
        } else {
            // Default to true for new forms from datapool if canEdit is not specified
            setCanEdit(true);
        }

        // Fetch field permissions for "Yeni Çağrı Formu" if dynamicCallFormStates is available
        if (dynamicCallFormStates && dynamicCallFormStates['Yeni Çağrı Formu']) {
            const stateId = dynamicCallFormStates['Yeni Çağrı Formu'];
            fetchFieldPermissions(stateId);
        }
    };

    // Function to get the next state ID based on current state name and action
    const getNextState = (action) => {
        // Ensure dynamic states and transitions are loaded
        if (loadingStates || !dynamicStateTransitions || !dynamicCallFormStates) {
            console.warn("getNextState returning null: States/Transitions not loaded yet.");
            return null; // Indicate that the next state cannot be determined yet
        }

        // Special case for addExpense action
        if (action === 'addExpense') {
            toast.info('Masraf ekleme işlemi başlatılıyor...');
            const currentId = dynamicCallFormStates[currentFormState];
            console.log(`getNextState (addExpense): Returning current state ID: ${currentId}`);
            return currentId || null; // Return current state's ID
        }

        // Get the potential next state ID from the dynamically generated transitions
        const transitionsForCurrent = dynamicStateTransitions[currentFormState];
        const nextStateId = transitionsForCurrent?.[action];

        // Return the found next state ID, or the current state's ID if no transition defined
        const currentStateId = dynamicCallFormStates[currentFormState];
        const resultId = nextStateId !== undefined ? nextStateId : currentStateId;
        console.log(`getNextState returning: ${resultId} (Current state ID was: ${currentStateId})`);
        return resultId;
    };

    // --- HELPER FUNCTIONS ---

    // Helper function to format dates or return empty string
    const formatDateForFormData = (date) => {
        // Return null if date is invalid or null/undefined
        return date instanceof Date && !isNaN(date) ? date.toISOString() : null;
    };    // --- Main Submission Function ---
    const handleFormSubmission = async (action, additionalParams = {}) => {
        if (!validateForm()) {
            toast.error('Lütfen zorunlu alanları doldurun.');
            return;
        }
        // Ensure dynamic states AND transitions are loaded before submission
        if (loadingStates || !dynamicCallFormStates || !dynamicStateTransitions) {
            toast.warning('Durum bilgileri veya geçiş kuralları henüz yükleniyor, lütfen bekleyin.');
            return;
        }

        try {
            setLoading(true); // Set loading true at the start of submission logic
            // Get the next state ID directly using the updated getNextState function
            const stateId = getNextState(action); // Call the instrumented function

            // Check if stateId could be determined
            if (stateId === undefined || stateId === null) { // Check for undefined or null
                console.error(`handleFormSubmission: Could not determine the next state ID for action '${action}' from state '${currentFormState}'. getNextState returned:`, stateId);
                toast.error(`Bir sonraki durum ID'si belirlenemedi.`);
                return;
            }
            console.log(`handleFormSubmission: Determined next state ID: ${stateId}`);

            // Prepare comments (unchanged)
            const currentDepartment = callFormStateMappings[currentFormState];
            const userFullName = localStorage.getItem('userFullName') || 'Kullanıcı'; // Kullanıcı adını al
            // ... (comment preparation logic remains the same) ...
            let updatedComments = [...existingComments];
            const existingCommentIndex = updatedComments.findIndex(
                comment => comment.commentType === currentDepartment
            );
            if (formData.notes && formData.notes.trim()) {
                const commentTypeWithUser = `${currentDepartment} - ${userFullName}`; // Kullanıcı adını commentType'a ekle
                
                if (existingCommentIndex >= 0) {
                    updatedComments[existingCommentIndex] = {
                        ...updatedComments[existingCommentIndex],
                        commentType: commentTypeWithUser,
                        comment: formData.notes.trim()
                    };
                } else {
                    updatedComments.push({
                        commentType: commentTypeWithUser,
                        comment: formData.notes.trim()
                    });
                }
            }

            // Create FormData object - File handling removed since FilesComponent handles uploads independently
            const formDataToSend = new FormData();
            // FilesComponent handles its own file uploads via /UploadedFile endpoint
            // No need to append files here as they're already uploaded and associated


            // --- 3. Append other form data fields manually using dot/bracket notation ---
            const safeAppend = (key, value) => {
                // Send nulls as empty strings for FormData, unless it's a boolean
                if (typeof value === 'boolean') {
                    formDataToSend.append(key, value);
                } else {
                    formDataToSend.append(key, value === null || value === undefined ? '' : value);
                }
            };

            // Remove DataPoolId append from here
            // if (isNewFormFromDataPool && id) {
            //     safeAppend('DataPoolId', id);
            //     console.log(`Appended DataPoolId: ${id}`);
            // }            // Top-level simple fields
            // Make sure CallFormNumber is not sending the DataPoolId when creating new
            safeAppend('CallFormNumber', isNewFormFromDataPool ? '' : id);
            safeAppend('PoaStatus', formData.poaStatus);
            // Append the determined state ID directly
            // API'nin hem yeni oluşturma hem de güncelleme için state ID beklediğini varsayıyoruz.
            // Bu nedenle if(id) kontrolünü kaldırıyoruz.
            safeAppend('CallFormState', stateId); // Use the ID returned by getNextState

            // Handle expert review requirement for return action
            if (action === 'return' && additionalParams.needExpertReview !== undefined) {
                safeAppend('NeedExpertReview', additionalParams.needExpertReview);
            }

            // ... (appending Customer data - unchanged) ...
            const customerData = formData;
            safeAppend('Customer.CustomerType', customerData.customerType);
            safeAppend('Customer.ClientName', customerData.clientName);
            safeAppend('Customer.CompanyName', customerData.companyName);
            safeAppend('Customer.IdentityNumber', customerData.tcid);
            safeAppend('Customer.TaxNumber', customerData.taxNumber);
            safeAppend('Customer.CrsNumber', customerData.crsNumber);
            safeAppend('Customer.ContractRate', customerData.customerContractRate); // Changed to customerContractRate
            safeAppend('Customer.CompanyRepresentative', customerData.companyRepresentative);
            safeAppend('Customer.Middleman', customerData.middleman);
            safeAppend('Customer.MiddlemanIban', customerData.middlemanIban);
            safeAppend('Customer.IsMiddlemanContractBased', customerData.customerIsMiddlemanContractBased); // Changed
            safeAppend('Customer.MiddlemanContractRate', customerData.customerMiddlemanContractRate); // Changed
            safeAppend('Customer.MiddlemanContractPrice', customerData.customerMiddlemanContractPrice); // Changed
            safeAppend('Customer.ContractOriginalArrived', customerData.hasContractArrived === "yes");
            safeAppend('Customer.Address', customerData.address);
            safeAppend('Customer.Reference', customerData.reference);
            if (customerData.agentId) safeAppend('Customer.Agent[0]', customerData.agentId);
            if (customerData.district) safeAppend('Customer.District[0]', customerData.district);

            const emails = [
                ...(customerData.email ? [{ EmailDescription: customerData.emailDescription || "Ana E-posta", Email: customerData.email }] : []),
                ...(customerData.email2 ? [{ EmailDescription: customerData.emailDescription2 || "İkinci E-posta", Email: customerData.email2 }] : [])
            ];
            emails.forEach((email, index) => {
                safeAppend(`Customer.Emails[${index}].EmailDescription`, email.EmailDescription);
                safeAppend(`Customer.Emails[${index}].Email`, email.Email);
            });
            const ibans = [
                ...(customerData.iban ? [{ IbanDescription: customerData.ibanDescription || "Ana Hesap", Iban: customerData.iban }] : []),
                ...(customerData.iban2 ? [{ IbanDescription: formData.ibanDescription2 || "İkinci Hesap", Iban: formData.iban2 }] : [])
            ];
            ibans.forEach((iban, index) => {
                safeAppend(`Customer.Ibans[${index}].IbanDescription`, iban.IbanDescription);
                safeAppend(`Customer.Ibans[${index}].Iban`, iban.Iban);
            });
            const phones = [
                ...(customerData.phoneNumber ? [{ PhoneDescription: customerData.phoneDescription || "Ana Telefon", Phone: customerData.phoneNumber }] : []),
                ...(customerData.phoneNumber2 ? [{ PhoneDescription: customerData.phoneDescription2 || "İkinci Telefon", Phone: customerData.phoneNumber2 }] : [])
            ];
            phones.forEach((phone, index) => {
                safeAppend(`Customer.Phones[${index}].PhoneDescription`, phone.PhoneDescription);
                safeAppend(`Customer.Phones[${index}].Phone`, phone.Phone);
            });

            // ... (appending LicensePlate data - unchanged) ...
            const plateData = formData;
            safeAppend('LicensePlate.LicensePlateNumber', plateData.licensePlate);
            safeAppend('LicensePlate.CarchassisNumber', plateData.chassisNumber);
            safeAppend('LicensePlate.IsThereLovClaim', plateData.isThereLovClaim === "yes");
            if (plateData.isThereLovClaim === "yes") {
                safeAppend('LicensePlate.LovClaimAmount', plateData.lovClaimAmount);
            }
            safeAppend('LicensePlate.LpImpeachmentStatus', plateData.lpImpeachmentStatus === "yes");
            if (plateData.lpImpeachmentStatus === "yes" || plateData.lpImpeachmentStatus === true) {
                safeAppend('LicensePlate.LpImpeachmentAmount', plateData.lpImpeachmentAmount);
            }

            safeAppend('LicensePlate.HasCarSoldBefore', plateData.hasCarSoldBefore === "yes");
            safeAppend('LicensePlate.CarBrand', plateData.carBrand);
            safeAppend('LicensePlate.CarModel', plateData.carModel);
            safeAppend('LicensePlate.CarYear', plateData.carYear);
            safeAppend('LicensePlate.CarOwner', plateData.clientName || plateData.companyName);
            safeAppend('LicensePlate.Description', null);
            // LicensePlate specific contract/middleman fields
            safeAppend('LicensePlate.CustomerContractRate', plateData.licensePlateCustomerContractRate);
            safeAppend('LicensePlate.IsMiddlemanContractBased', plateData.licensePlateIsMiddlemanContractBased);
            safeAppend('LicensePlate.MiddlemanContractRate', plateData.licensePlateMiddlemanContractRate);
            safeAppend('LicensePlate.MiddlemanContractPrice', plateData.licensePlateMiddlemanContractPrice);

            const trafficPolicy = plateData.trafficInsurancePolicy;
            if (trafficPolicy?.trafficInsuranceProvider?.length > 0) {
                trafficPolicy.trafficInsuranceProvider.forEach((providerId, idx) => {
                    safeAppend(`LicensePlate.TrafficInsurancePolicy.TrafficInsuranceProvider[${idx}]`, providerId);
                });
            }
            safeAppend('LicensePlate.TrafficInsurancePolicy.TrafficInsuranceNumber', trafficPolicy?.trafficInsuranceNumber);
            safeAppend('LicensePlate.TrafficInsurancePolicy.TrafficInsuranceStart', formatDateForFormData(trafficPolicy?.trafficInsuranceStart));
            safeAppend('LicensePlate.TrafficInsurancePolicy.TrafficInsuranceExpiry', formatDateForFormData(trafficPolicy?.trafficInsuranceExpiry));
            const cascoPolicy = plateData.cascoInsurancePolicy;
            if (cascoPolicy?.cascoInsuranceProvider?.length > 0) {
                cascoPolicy.cascoInsuranceProvider.forEach((providerId, idx) => {
                    safeAppend(`LicensePlate.CascoInsurancePolicy.CascoInsuranceProvider[${idx}]`, providerId);
                });
            }
            safeAppend('LicensePlate.CascoInsurancePolicy.CascoInsuranceNumber', cascoPolicy?.cascoInsuranceNumber);
            safeAppend('LicensePlate.CascoInsurancePolicy.CascoInsuranceStart', formatDateForFormData(cascoPolicy?.cascoInsuranceStart));
            safeAppend('LicensePlate.CascoInsurancePolicy.CascoInsuranceExpiry', formatDateForFormData(cascoPolicy?.cascoInsuranceExpiry));
            safeAppend('LicensePlate.IsThereOpenDamageFile', plateData.isThereOpenDamageFile === "yes");

            // ... (appending PowerOfAttorney data - unchanged) ...
            const poaData = formData;
            safeAppend('PowerOfAttorney.PoaNumber', poaData.powerOfAttorneyNumber);
            safeAppend('PowerOfAttorney.PoaDate', formatDateForFormData(poaData.powerOfAttorneyDate));
            safeAppend('PowerOfAttorney.IsPoaTimeLimited', poaData.isPowerOfAttorneyTimed === "yes");
            safeAppend('PowerOfAttorney.PoaEndDate', poaData.isPowerOfAttorneyTimed === "yes" ? formatDateForFormData(poaData.powerOfAttorneyEndDate) : null); // Use null if not timed
            safeAppend('PowerOfAttorney.NotaryOfPoa', poaData.notaryNumber);
            safeAppend('PowerOfAttorney.IsLicensePlatesLimited', poaData.isLicensePlatesLimited === "yes");
            safeAppend('PowerOfAttorney.IsAccidentDateLimited', poaData.isAccidentDateLimited === "yes");
            safeAppend('PowerOfAttorney.LicensePlateLimitAccidentDate', poaData.isLicensePlatesLimited === "yes" && poaData.isAccidentDateLimited === "yes" ? formatDateForFormData(poaData.plateLimitAccidentDate) : null); // Conditional date
            safeAppend('PowerOfAttorney.PoaOriginalArrived', poaData.hasOriginalArrived === "yes");
            safeAppend('PowerOfAttorney.ContractRate', poaData.contractRate);
            if (poaData.isLicensePlatesLimited === "yes" && Array.isArray(poaData.plateLimit)) {
                poaData.plateLimit.forEach((plateId, idx) => {
                    safeAppend(`PowerOfAttorney.LicensePlateLimit[${idx}]`, plateId);
                });
            }

            // ... (appending Accident data - unchanged) ...
            const accidentData = formData;
            safeAppend('Accident.AccidentDate', formatDateForFormData(accidentData.accidentDate));
            safeAppend('Accident.CounterpartyType', accidentData.counterpartyType);
            safeAppend('Accident.CounterpartyIdentificationNumber', accidentData.counterpartyIdentificationNumber);
            safeAppend('Accident.CounterpartyTaxNumber', accidentData.counterpartyTaxNumber);
            safeAppend('Accident.CounterpartyCarOwner', accidentData.counterpartyCarOwner);
            safeAppend('Accident.CounterpartyLicensePlateNumber', accidentData.counterpartyLicensePlateNumber);
            safeAppend('Accident.CounterpartyAddress', accidentData.counterpartyAddress);
            safeAppend('Accident.IsTrialDocument', accidentData.isTrialDocument === "yes");
            safeAppend('Accident.IsWorkDocument', accidentData.isWorkDocument === "yes");
            safeAppend('Accident.BonusEligibility', accidentData.bonusEligibility);
            safeAppend('Accident.ShouldPayNotaryFee', accidentData.shouldPayNotaryFee === "yes");
            safeAppend('Accident.NotaryFeeAmount', accidentData.shouldPayNotaryFee === "yes" ? accidentData.notaryFeeAmount : '');
            safeAppend('Accident.EstimatedDepreciationAmount', accidentData.estimatedDepreciationAmount);
            safeAppend('Accident.DamageAmount', accidentData.damageAmount);
            safeAppend('Accident.DamageDifferenceAmount', accidentData.damageDifferenceAmount);
            safeAppend('Accident.LoRamount', accidentData.lorAmount);
            safeAppend('Accident.OurFaultRate', accidentData.ourFaultRate);
            safeAppend('Accident.CounterPartyFaultRate', accidentData.counterpartyFaultRate);
            safeAppend('Accident.WillLorBeWorked', accidentData.willLorBeWorked === "yes");
            safeAppend('Accident.DocumentRequestDate', formatDateForFormData(accidentData.documentRequestDate));
            safeAppend('Accident.DocumentReceivedDate', formatDateForFormData(accidentData.documentReceivedDate));

            const cpTrafficPolicy = accidentData.counterpartyTrafficInsurancePolicy;
            if (cpTrafficPolicy?.trafficInsuranceProvider?.length > 0) {
                cpTrafficPolicy.trafficInsuranceProvider.forEach((providerId, idx) => {
                    safeAppend(`Accident.CounterpartyTrafficInsurancePolicy.TrafficInsuranceProvider[${idx}]`, providerId);
                });
            }
            safeAppend('Accident.CounterpartyTrafficInsurancePolicy.TrafficInsuranceNumber', cpTrafficPolicy?.trafficInsuranceNumber);
            safeAppend('Accident.CounterpartyTrafficInsurancePolicy.TrafficInsuranceStart', formatDateForFormData(cpTrafficPolicy?.trafficInsuranceStart));
            safeAppend('Accident.CounterpartyTrafficInsurancePolicy.TrafficInsuranceExpiry', formatDateForFormData(cpTrafficPolicy?.trafficInsuranceExpiry));
            const cpCascoPolicy = accidentData.counterpartyCascoInsurancePolicy;
            if (cpCascoPolicy?.cascoInsuranceProvider?.length > 0) {
                cpCascoPolicy.cascoInsuranceProvider.forEach((providerId, idx) => {
                    safeAppend(`Accident.CounterpartyCascoInsurancePolicy.CascoInsuranceProvider[${idx}]`, providerId);
                });
            }
            safeAppend('Accident.CounterpartyCascoInsurancePolicy.CascoInsuranceNumber', cpCascoPolicy?.cascoInsuranceNumber);
            safeAppend('Accident.CounterpartyCascoInsurancePolicy.CascoInsuranceStart', formatDateForFormData(cpCascoPolicy?.cascoInsuranceStart));
            safeAppend('Accident.CounterpartyCascoInsurancePolicy.CascoInsuranceExpiry', formatDateForFormData(cpCascoPolicy?.cascoInsuranceExpiry));

            // ... (appending AccidentFile data - unchanged) ...
            const accidentFileData = formData;
            safeAppend('AccidentFile.FileNumber', accidentFileData.fileNumber);
            safeAppend('AccidentFile.FileOpenDate', formatDateForFormData(accidentFileData.registrationDate));
            safeAppend('AccidentFile.FileStatus', accidentFileData.fileStatus);
            safeAppend('AccidentFile.WhoseInsurance', accidentFileData.whoseInsurance);
            safeAppend('AccidentFile.DocumentRequestStatus', accidentFileData.documentRequestStatus);
            safeAppend('AccidentFile.ImpeachmentStatus', '');

            if (accidentFileData.customerId) safeAppend('AccidentFile.Customer[0]', accidentFileData.customerId);
            if (accidentFileData.accidentId) safeAppend('AccidentFile.Accident.Id', accidentFileData.accidentId);
            if (accidentFileData.jobToBeWorked && Array.isArray(accidentFileData.jobToBeWorked)) {
                accidentFileData.jobToBeWorked.forEach((jobId, idx) => {
                    safeAppend(`AccidentFile.JobToBeWorked[${idx}]`, jobId);
                });
            } else if (accidentFileData.jobToBeWorked) {
                safeAppend(`AccidentFile.JobToBeWorked[0]`, accidentFileData.jobToBeWorked);
            }            
            
            // Yeni API formatına göre FilesToBeWorked dosyalarını işle
            // Her dosya bir MultipleAccidentFile elemanı olacak
            console.log('Çalışılacak dosyalar (yeni format):', accidentFileData.filesToBeWorked);
            
            accidentFileData.filesToBeWorked.forEach((ftw, accidentFileIndex) => {
                console.log(`Dosya ${accidentFileIndex}:`, ftw);
                
                // MultipleAccidentFile için temel bilgiler
                safeAppend(`MultipleAccidentFile[${accidentFileIndex}].WithReport`, ftw.withReport);
                safeAppend(`MultipleAccidentFile[${accidentFileIndex}].WithFault`, ftw.withFault);
                safeAppend(`MultipleAccidentFile[${accidentFileIndex}].WithoutReport`, ftw.withoutReport);

                // Her dosyada seçilen dosya türlerini FileTypeAndExpense olarak ekle
                if (ftw.fileType && Array.isArray(ftw.fileType)) {
                    ftw.fileType.forEach((typeId, fileTypeIndex) => {
                        const ftwPrefix = `MultipleAccidentFile[${accidentFileIndex}].FileTypeAndExpense[${fileTypeIndex}]`;
                        
                        // Dosya türü ID'sini ekle
                        safeAppend(`${ftwPrefix}.FileType`, typeId);

                        // Her dosya türü için ayrı tutarı kullan
                        let fileExpense = 0;
                        
                        // Yeni veri yapısında fileTypeExpenseDetails varsa onu kullan
                        if (ftw.fileTypeExpenseDetails && ftw.fileTypeExpenseDetails[typeId] !== undefined) {
                            fileExpense = ftw.fileTypeExpenseDetails[typeId];
                            
                            // Hak mahrumiyeti türü ise ek alanları da ekle
                            const isLorType = workFileTypes && workFileTypes.find(type => {
                                if (type.id === typeId) {
                                    const title = type.title ? type.title.toLowerCase() : '';
                                    return title.includes('hak mahrumiyeti') || 
                                           title.includes('lor') || 
                                           title.includes('mahrumiyeti');
                                }
                                return false;
                            });

                            if (isLorType) {
                                safeAppend(`${ftwPrefix}.NumberOfDays`, ftw.numberOfDays || 0);
                                safeAppend(`${ftwPrefix}.ExpensePerDay`, ftw.expensePerDay || 0);
                            }
                        } 
                        // Eski veri yapısı için backward compatibility
                        else {
                            // Hak mahrumiyeti türü mü kontrol et
                            const isLorType = workFileTypes && workFileTypes.find(type => {
                                if (type.id === typeId) {
                                    const title = type.title ? type.title.toLowerCase() : '';
                                    return title.includes('hak mahrumiyeti') || 
                                           title.includes('lor') || 
                                           title.includes('mahrumiyeti');
                                }
                                return false;
                            });

                            if (isLorType) {
                                // Hak mahrumiyeti için hesaplanan tutar ve ek alanlar
                                safeAppend(`${ftwPrefix}.NumberOfDays`, ftw.numberOfDays || 0);
                                safeAppend(`${ftwPrefix}.ExpensePerDay`, ftw.expensePerDay || 0);
                                fileExpense = ftw.lorExpense || (ftw.numberOfDays * ftw.expensePerDay) || 0;
                            } else {
                                // Eski format için diğer dosya türleri
                                fileExpense = ftw.fileExpense || 0;
                            }
                        }

                        // FileExpense'i ekle
                        safeAppend(`${ftwPrefix}.FileExpense`, fileExpense);
                        console.log(`Dosya türü ${typeId} - Tutar: ${fileExpense}`);
                    });
                }
            });
            updatedComments.forEach((comment, index) => {
                safeAppend(`Comments[${index}].CommentType`, comment.commentType);
                safeAppend(`Comments[${index}].Comment`, comment.comment);
            });

            // --- Logging and Sending --- (unchanged)
            console.log('FormData keys being sent:');
            // ... logging ...
            for (let key of formDataToSend.keys()) {
                console.log(key);
            }
            console.log('FormData values (non-file):');
            for (let pair of formDataToSend.entries()) {
                if (!(pair[1] instanceof File)) {
                    console.log(pair[0] + ': ' + pair[1]);
                } else {
                    console.log(pair[0] + ': [File Object]');
                }
            }

            // --- Updated Request Logic ---
            let response;
            let requestUrl = callformApiUrl; // Default URL

            try {
                // setLoading(true); // Zaten yukarıda ayarlandı, tekrar gerek yok.

                const accessToken = localStorage.getItem('accessToken');

                if (!accessToken) {
                    console.error('Authentication token not found!');
                    toast.error('Yetkilendirme hatası: Token bulunamadı.');
                    setLoading(false); // <-- Token yoksa loading'i false yap ve çık
                    return;
                }

                const headers = {
                    'Authorization': `Bearer ${accessToken}`,
                    // Content-Type'ı FormData için axios otomatik ayarlar, elle eklemeyin.
                    // 'Content-Type': 'application/json',
                };

                if (isNewFormFromDataPool) {
                    // Always POST when creating from DataPool
                    // Append DataPoolId as a query parameter
                    requestUrl = `${callformApiUrl}?DataPoolId=${id}`;
                    console.log(`Sending POST request to create new call form: ${requestUrl}`);
                    response = await axios({
                        method: 'post',
                        url: requestUrl,
                        headers: headers, // <-- Header'ları ekle
                        data: formDataToSend,
                    });
                } else {
                    // Existing logic: PUT if id exists (editing), POST if no id (new)
                    if (id) {
                        requestUrl = `${callformApiUrl}/${id}`; // URL for PUT
                    }
                    console.log(`Sending ${id ? 'PUT' : 'POST'} request to ${requestUrl}`);
                    response = await axios({
                        method: id ? 'put' : 'post',
                        url: requestUrl,
                        headers: headers, // <-- Header'ları ekle
                        data: formDataToSend,
                    });
                }


            } catch (error) {
                console.error('API Hatası:', error.response ? error.response.data : error.message);
                toast.error('İşlem sırasında bir hata oluştu.');
                setLoading(false); // <-- API hatası durumunda loading'i false yap
                return;
            }

            console.log('API Yanıtı:', response.data);
            toast.success('İşlem başarıyla tamamlandı.');

            // Başarılı işlem sonrası Yapılacaklar Listesi'ne yönlendirme
            navigate('/todo-list'); // URL '/todo-list' olarak değiştirildi

        } catch (error) {
            // Bu dış try-catch genel hataları yakalar (state belirleme, comment hazırlama vb.)
            console.error('Form İşleme Hatası:', error.response ? error.response.data : error.message);
            toast.error('İşlem sırasında genel bir hata oluştu.');
            // setLoading(false); // finally bloğu bunu zaten yapıyor
        } finally {
            setLoading(false); // <-- İşlem bitince (başarılı veya başarısız) loading'i false yap
        }
    };

    const resetForm = () => {
        setFormData({
            recipientOfPowerOfAttorney: null,
            agentId: null,
            registrationDate: null,
            clientName: null,  // Bireysel
            companyName: null, // Kurumsal
            tcid: null, // Bireysel
            crsNumber: null, // Kurumsal
            taxNumber: null, // Kurumsal
            isThereLovClaim: null,
            hasCarSoldBefore: null,
            isTrialDocument: "no",
            isWorkDocument: "no",  // Changed from willLorBeWorked
            bonusEligibility: null,
            shouldPayNotaryFee: null,
            notaryFeeAmount: null,
            licensePlate: null,
            chassisNumber: null,
            carBrand: null,
            carModel: null,
            carYear: null,
            estimatedDepreciationAmount: null,
            damageAmount: null,
            damageDifferenceAmount: null,
            lorAmount: null,
            accidentDate: null,
            faultRate: null,
            phoneNumber: null,
            phoneNumber2: null,
            // Telefon açıklamaları için alanlar ekleyelim
            phoneDescription: null,
            phoneDescription2: null,
            companyRepresentative: null, // Kurumsal
            email: null,
            email2: null,
            // Email açıklamaları için alanlar ekleyelim
            emailDescription: null,
            emailDescription2: null,
            iban: null,
            iban2: null,
            // IBAN açıklamaları için alanlar ekleyelim
            ibanDescription: null,
            ibanDescription2: null,
            middleman: null,
            middlemanIban: null,
            MiddlemanContractRate: null,
            isMiddlemanContractBased: false, // Yeni alan reset değeri
            middlemanContractPrice: null, // Yeni alan reset değeri
            isPowerOfAttorneyTimed: null,
            powerOfAttorneyDate: null,
            powerOfAttorneyEndDate: null,
            powerOfAttorneyNumber: null,
            notaryNumber: null,
            contractRate: null,
            isLicensePlatesLimited: null,
            plateLimit: [],
            isAccidentDateLimited: null,
            plateLimitAccidentDate: null,
            hasOriginalArrived: null,
            hasContractArrived: null,
            reference: null,
            city: null,
            district: null,
            address: null,
            notes: null,
            customerType: 'Bireysel',

            isThereOpenDamageFile: null,
            jobToBeWorked: null,
            whoseInsurance: null,
            documentRequestDate: null,
            documentRequestStatus: null,
            documentReceivedDate: null,

            filesToBeWorked: [],

            trafficInsurancePolicy: {
                trafficInsuranceProvider: [],
                trafficInsuranceNumber: null,
                trafficInsuranceExpiry: null,
                trafficInsuranceStart: null,
            },

            cascoInsurancePolicy: {
                cascoInsuranceProvider: [],
                cascoInsuranceNumber: null,
                cascoInsuranceExpiry: null,
                cascoInsuranceStart: null,
            },

            counterpartyType: 'Bireysel',
            counterpartyIdentificationNumber: null,
            counterpartyTaxNumber: null,
            counterpartyCarOwner: null,
            counterpartyLicensePlateNumber: null,
            counterpartyAddress: null,

            counterpartyTrafficInsurancePolicy: {
                trafficInsuranceProvider: [],
                trafficInsuranceNumber: null,
                trafficInsuranceExpiry: null,
                trafficInsuranceStart: null,
            },

            counterpartyCascoInsurancePolicy: {
                cascoInsuranceProvider: [],
                cascoInsuranceNumber: null,
                cascoInsuranceExpiry: null,
                cascoInsuranceStart: null,
            },

            ourFaultRate: null,
            counterpartyFaultRate: null,

            willLorBeWorked: "no",  // Varsayılan değer "no" olarak ayarlandı
        });
        setErrors({});

        // selectedFiles state removed - FilesComponent handles its own file management
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        let processedValue = type === 'checkbox' ? checked : value;

        // BÜYÜK HARFE ÇEVRİLECEK ALANLAR LİSTESİ - middleman çıkarıldı
        const fieldsToUppercase = [
            /* 'clientName', */ // clientName zaten çıkarılmıştı
            'companyName', 'tcid', 'crsNumber', 'taxNumber',
            'licensePlate', 'chassisNumber', 'carBrand', 'carModel',
            'companyRepresentative', 'iban', 'iban2', /* 'middleman', */ // middleman'i buradan kaldırıyoruz
            'middlemanIban',
            'powerOfAttorneyNumber', 'notaryNumber', 'reference', 'address',
            'counterpartyIdentificationNumber', 'counterpartyTaxNumber',
            'counterpartyCarOwner', 'counterpartyLicensePlateNumber', 'counterpartyAddress',
            'recipientOfPowerOfAttorney',
            'phoneDescription', 'phoneDescription2',
            'emailDescription', 'emailDescription2',
            'ibanDescription', 'ibanDescription2',
        ];

        // Check if the field should be uppercased AND it's a string
        if (fieldsToUppercase.includes(name) && typeof value === 'string') {
            processedValue = value.toLocaleUpperCase('tr-TR');
        }
        // Specific handling for email fields (lowercase)
        else if (name === 'email' || name === 'email2') {
            processedValue = value ? String(value).toLowerCase() : '';
        }
        // Optional: Handle middleman formatting if needed, but validation already checks
        // else if (name === 'middleman' && typeof value === 'string') {
        //    processedValue = value
        //        .toLowerCase()
        //        .split(' ')
        //        .map(word => word.charAt(0).toLocaleUpperCase('tr-TR') + word.slice(1))
        //        .join(' ');
        // }


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: processedValue,
            };

            // Mirror customer contract/middleman changes to license plate fields
            if (name === 'customerContractRate') {
                updatedFormData.licensePlateCustomerContractRate = processedValue;
            } else if (name === 'customerIsMiddlemanContractBased') {
                updatedFormData.licensePlateIsMiddlemanContractBased = processedValue; // processedValue burada boolean olmalı
                if (processedValue === true) { // Doğrudan boolean kontrolü
                    updatedFormData.customerMiddlemanContractPrice = null;
                    updatedFormData.licensePlateMiddlemanContractPrice = null;
                } else {
                    updatedFormData.customerMiddlemanContractRate = null;
                    updatedFormData.licensePlateMiddlemanContractRate = null;
                }
            } else if (name === 'customerMiddlemanContractRate') {
                updatedFormData.licensePlateMiddlemanContractRate = processedValue;
            } else if (name === 'customerMiddlemanContractPrice') {
                updatedFormData.licensePlateMiddlemanContractPrice = processedValue;
            }
            // Not: licensePlateIsMiddlemanContractBased için ayrı bir UI olmadığından,
            // onun değişimiyle ilgili rate/price temizleme mantığına burada gerek yok,
            // çünkü customerIsMiddlemanContractBased değiştiğinde licensePlate versiyonları da güncelleniyor.

            return updatedFormData;
        });

        // Eğer Hak Mahrumiyeti Çalışılacak Mı alanı "no" olarak değiştirilirse not ekle
        if (name === 'willLorBeWorked' && value === 'no') {
            // ... (mevcut not ekleme mantığı değişmedi) ...
            const currentDepartment = callFormStateMappings[currentFormState];
            let updatedComments = [...existingComments];

            const existingCommentIndex = updatedComments.findIndex(
                comment => comment.commentType === currentDepartment
            );

            const lorNote = "Hak mahrumiyeti çalışılmayacak olarak işaretlendi.";

            if (existingCommentIndex >= 0) {
                const existingComment = updatedComments[existingCommentIndex].comment;
                if (!existingComment.includes(lorNote)) {
                    updatedComments[existingCommentIndex] = {
                        ...updatedComments[existingCommentIndex],
                        comment: existingComment ? `${existingComment}\n${lorNote}` : lorNote
                    };
                }
            } else {
                updatedComments.push({
                    commentType: currentDepartment,
                    comment: lorNote
                });
            }
            setExistingComments(updatedComments);
        }

        // Clear errors when the user interacts with a field
        if (errors[name]) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: undefined,
            }));
        }
    };

    const handleAddWorkFile = (newFile) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            filesToBeWorked: [
                ...prevFormData.filesToBeWorked,
                newFile
            ]
        }));
    };

    const handleRemoveWorkFile = (index) => {
        const updatedFiles = [...formData.filesToBeWorked];
        updatedFiles.splice(index, 1);
        setFormData((prevFormData) => ({
            ...prevFormData,
            filesToBeWorked: updatedFiles
        }));
    };

    const handleCustomerTypeChange = (e) => {
        const newCustomerType = e.target.value;
        setFormData((prevFormData) => ({
            ...prevFormData,
            customerType: newCustomerType,
            clientName: newCustomerType === 'Bireysel' ? prevFormData.clientName : null,
            tcid: newCustomerType === 'Bireysel' ? prevFormData.tcid : null,
            companyName: newCustomerType === 'Kurumsal' ? prevFormData.companyName : null,
            crsNumber: newCustomerType === 'Kurumsal' ? prevFormData.crsNumber : null,
            taxNumber: newCustomerType === 'Kurumsal' ? prevFormData.taxNumber : null,
            lorAmount: newCustomerType === 'Kurumsal' ? prevFormData.lorAmount : null,
            companyRepresentative: newCustomerType === 'Kurumsal' ? prevFormData.companyRepresentative : null,
            email: newCustomerType === 'Kurumsal' ? prevFormData.email : null,
        }));
    };

    const handleCounterPartyTypeChange = (e) => {
        const newCounterPartyType = e.target.value;
        setFormData((prevFormData) => ({
            ...prevFormData,
            counterpartyType: newCounterPartyType,
            counterpartyIdentificationNumber: newCounterPartyType === 'Bireysel' ? prevFormData.counterpartyIdentificationNumber : null,
            counterpartyTaxNumber: newCounterPartyType === 'Kurumsal' ? prevFormData.counterpartyTaxNumber : null,
        }));
    };

    const validateForm = () => {
        let newErrors = {};

        // Validate required fields based on fieldPermissions
        fieldPermissions.forEach(permission => {
            if (permission.required) {
                const fieldPath = permission.fieldName.split('.');
                let value = formData;
                let isValid = true;
                let currentPath = 'formData'; // For logging

                // Traverse the formData object based on the path
                for (const key of fieldPath) {
                    currentPath += `.${key}`; // Build the path string for logging

                    // Check if the current level is null or undefined
                    if (value === null || value === undefined) {
                        console.warn(`Validation check: Path ${currentPath} is accessing a property on null/undefined.`);
                        isValid = false;
                        break;
                    }

                    // Check if the key exists at the current level
                    if (!value.hasOwnProperty(key) || value[key] === undefined || value[key] === null) {
                        // Allow null/undefined if it's the *last* key in the path (the actual field value)
                        // but break if it's an intermediate object that's missing/null
                        if (key !== fieldPath[fieldPath.length - 1]) {
                            console.warn(`Validation check: Intermediate object missing or null at ${currentPath}.`);
                            isValid = false;
                            break;
                        } else {
                            // It's the final key, so null/undefined is a valid state to check against later
                            value = value[key]; // This will be null or undefined
                            console.log(`Validation check: Final value at ${currentPath} is null/undefined.`);
                        }
                    } else {
                        // Key exists and is not null/undefined, proceed deeper
                        value = value[key];
                        console.log(`Validation check: Traversing to ${currentPath}, value is:`, value);
                    }
                }


                // Check if the final value is empty or considered invalid
                // Also check isValid flag which might be false from traversal issues
                if (!isValid || value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
                    console.log(`Validation failed for ${permission.fieldName}. Final value: ${value}, isValid: ${isValid}`);
                    // Map the API fieldName back to a form field name for the error message
                    // This mapping needs careful review and adjustment based on your exact formData structure and API field names
                    let formFieldName = permission.fieldName; // Default to API name

                    // --- SPECIFIC MAPPINGS (Adjust these carefully!) ---
                    // Customer
                    if (permission.fieldName === 'customer.clientname') formFieldName = 'clientName';
                    else if (permission.fieldName === 'customer.companyname') formFieldName = 'companyName';
                    else if (permission.fieldName === 'customer.identitynumber') formFieldName = 'tcid';
                    else if (permission.fieldName === 'customer.taxnumber') formFieldName = 'taxNumber';
                    else if (permission.fieldName === 'customer.crsnumber') formFieldName = 'crsNumber';
                    else if (permission.fieldName === 'customer.address') formFieldName = 'address';
                    else if (permission.fieldName === 'customer.district') formFieldName = 'district'; // Check if district is just the ID
                    // Contact (assuming first phone/email/iban is required if the permission is set)
                    else if (permission.fieldName === 'customer.phones.phone') formFieldName = 'phoneNumber';
                    else if (permission.fieldName === 'customer.emails.email') formFieldName = 'email';
                    else if (permission.fieldName === 'customer.ibans.iban') formFieldName = 'iban';
                    // POA Agent
                    else if (permission.fieldName === 'customer.agent') formFieldName = 'agentId'; // Or recipientOfPowerOfAttorney?

                    // License Plate
                    else if (permission.fieldName === 'licenseplate.licenseplatenumber') formFieldName = 'licensePlate';
                    else if (permission.fieldName === 'licenseplate.carchassisnumber') formFieldName = 'chassisNumber';
                    else if (permission.fieldName === 'licenseplate.carbrand') formFieldName = 'carBrand';
                    else if (permission.fieldName === 'licenseplate.carmodel') formFieldName = 'carModel';
                    else if (permission.fieldName === 'licenseplate.caryear') formFieldName = 'carYear';
                    // Insurance (assuming provider ID is what's required)
                    else if (permission.fieldName === 'licenseplate.trafficinsurancepolicy.trafficinsuranceprovider') formFieldName = 'trafficInsurancePolicy.trafficInsuranceProvider';
                    else if (permission.fieldName === 'licenseplate.cascoinsurancepolicy.cascoinsuranceprovider') formFieldName = 'cascoInsurancePolicy.cascoInsuranceProvider';


                    // Accident
                    else if (permission.fieldName === 'accident.accidentdate') formFieldName = 'accidentDate';
                    else if (permission.fieldName === 'accident.estimateddepreciationamount') formFieldName = 'estimatedDepreciationAmount';
                    else if (permission.fieldName === 'accident.damageamount') formFieldName = 'damageAmount';
                    // Counterparty
                    else if (permission.fieldName === 'accident.counterpartytype') formFieldName = 'counterpartyType';
                    else if (permission.fieldName === 'accident.counterpartyidentificationnumber') formFieldName = 'counterpartyIdentificationNumber';
                    else if (permission.fieldName === 'accident.counterpartytaxnumber') formFieldName = 'counterpartyTaxNumber';
                    else if (permission.fieldName === 'accident.counterpartycarowner') formFieldName = 'counterpartyCarOwner';
                    else if (permission.fieldName === 'accident.counterpartylicenseplatenumber') formFieldName = 'counterpartyLicensePlateNumber';
                    // Counterparty Insurance
                    else if (permission.fieldName === 'accident.counterpartytrafficinsurancepolicy.trafficinsuranceprovider') formFieldName = 'counterpartyTrafficInsurancePolicy.trafficInsuranceProvider';
                    else if (permission.fieldName === 'accident.counterpartycascoinsurancepolicy.cascoinsuranceprovider') formFieldName = 'counterpartyCascoInsurancePolicy.cascoInsuranceProvider';
                    // Fault Rates
                    else if (permission.fieldName === 'accident.ourfaultrate') formFieldName = 'ourFaultRate';
                    else if (permission.fieldName === 'accident.counterpartyfaultrate') formFieldName = 'counterpartyFaultRate';
                    // Expert
                    else if (permission.fieldName === 'accident.appointedexperts') formFieldName = 'appointedExperts'; // Check if it's the ID or object

                    // Power of Attorney
                    else if (permission.fieldName === 'powerofattorney.poanumber') formFieldName = 'powerOfAttorneyNumber';
                    else if (permission.fieldName === 'powerofattorney.poadate') formFieldName = 'powerOfAttorneyDate';
                    else if (permission.fieldName === 'powerofattorney.notaryofpoa') formFieldName = 'notaryNumber';
                    else if (permission.fieldName === 'powerofattorney.contractrate') formFieldName = 'contractRate';

                    // Accident File
                    else if (permission.fieldName === 'accidentfile.fileopendate') formFieldName = 'registrationDate';
                    else if (permission.fieldName === 'accidentfile.jobtobeworked') formFieldName = 'jobToBeWorked';
                    else if (permission.fieldName === 'accidentfile.whoseinsurance') formFieldName = 'whoseInsurance';
                    // Document Dates/Status
                    else if (permission.fieldName === 'accidentfile.documentrequestdate') formFieldName = 'documentRequestDate';
                    else if (permission.fieldName === 'accidentfile.documentrequeststatus') formFieldName = 'documentRequestStatus';
                    else if (permission.fieldName === 'accidentfile.documentreceiveddate') formFieldName = 'documentReceivedDate';

                    // Add more specific mappings as needed...
                    console.log(`Mapping API field '${permission.fieldName}' to form field '${formFieldName}' for error.`);
                    newErrors[formFieldName] = 'Bu alan zorunludur.';
                }
            }
        });


        // Add existing manual validations (optional, can be merged with above)
        // Example: if (formData.customerType === 'Bireysel' && !formData.clientName) newErrors.clientName = "Müşteri Adı (Bireysel) zorunludur.";
        // Example: if (formData.customerType === 'Kurumsal' && !formData.companyName) newErrors.companyName = "Şirket Adı (Kurumsal) zorunludur.";

        console.log('Validation Errors:', newErrors);
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // --- NEW Customer Search Function ---
    const handleCustomerSearch = async (idType, idValue) => {
        if (!idValue) {
            toast.warning('Lütfen arama yapmak için bir kimlik/vergi numarası girin.');
            return;
        }

        let searchParam = '';
        if (idType === 'tcid') {
            searchParam = `identityNumber=${idValue}`;
        } else if (idType === 'taxNumber') {
            searchParam = `taxNumber=${idValue}`;
        } else {
            toast.error('Geçersiz arama türü.');
            return;
        }

        try {
            const response = await fetchFormData({
                apiEndpoint: `${customerApiUrl}?${searchParam}`,
                page: 1,
                pageSize: 1,
            });

            console.log('Customer Search Response:', response);

            let customerData = null;
            let items = [];

            // --- Refined Extraction Logic ---
            // Prioritize the structure with 'items' array
            if (response?.isSuccess && response?.data && Array.isArray(response.data.items)) {
                items = response.data.items;
            } else if (response?.items && Array.isArray(response.items)) {
                items = response.items;
            } else if (Array.isArray(response)) {
                items = response;
                // Handle single object response *only if* items array check failed
            } else if (response?.data && typeof response.data === 'object' && !Array.isArray(response.data) && response.data.id) {
                // If API directly returns a single customer object inside 'data'
                customerData = response.data;
                console.log("Extracted single customer object directly from response.data");
            } else if (response && typeof response === 'object' && !Array.isArray(response) && response.id) {
                // If API directly returns a single customer object at the top level
                customerData = response;
                console.log("Extracted single customer object directly from response root");
            }

            // If items array was populated, take the first item
            if (items.length > 0) {
                customerData = items[0];
                console.log("Extracted customer from items array:", customerData);
            }
            // --- End of Refined Extraction Logic ---


            // --- Updated Check: Check if customerData is a valid object with an ID ---
            if (customerData && customerData.id) {
                console.log('Found valid customer:', customerData);
                toast.success('Müşteri bilgileri başarıyla getirildi.'); // Success only when customer is found

                // Update formData with found customer details
                // Carefully map API response fields to formData fields
                setFormData(prev => {
                    const districtId = customerData.district?.id || null;
                    const cityId = customerData.district?.city?.id || prev.city; // Keep existing city if district doesn't have one

                    // Prepare phones, emails, ibans from the fetched customer data
                    const phones = customerData.phones || [];
                    const emails = customerData.emails || [];
                    const ibans = customerData.ibans || [];

                    return {
                        ...prev,
                        // Customer Info
                        clientName: customerData.customerType === 'Bireysel' ? customerData.clientName : null,
                        companyName: customerData.customerType === 'Kurumsal' ? customerData.companyName : null,
                        companyRepresentative: customerData.customerType === 'Kurumsal' ? customerData.companyRepresentative : null,
                        // Keep the searched ID
                        tcid: idType === 'tcid' ? idValue : (customerData.customerType === 'Bireysel' ? customerData.identityNumber : null),
                        taxNumber: idType === 'taxNumber' ? idValue : (customerData.customerType === 'Kurumsal' ? customerData.taxNumber : null),
                        crsNumber: customerData.customerType === 'Kurumsal' ? customerData.crsNumber : null,
                        customerType: customerData.customerType || prev.customerType, // Update type if found
                        agentId: customerData.agent?.id || null,
                        recipientOfPowerOfAttorney: customerData.agent ? `${customerData.agent.name || ''} ${customerData.agent.surname || ''}`.trim() : null,

                        // Contact Info - Map carefully from arrays
                        phoneNumber: phones[0]?.phone || null,
                        phoneDescription: phones[0]?.phoneDescription || null,
                        phoneNumber2: phones[1]?.phone || null,
                        phoneDescription2: phones[1]?.phoneDescription || null,
                        email: emails[0]?.email || null,
                        emailDescription: emails[0]?.emailDescription || null,
                        email2: emails[1]?.email || null,
                        emailDescription2: emails[1]?.emailDescription || null,
                        iban: ibans[0]?.iban || null,
                        ibanDescription: ibans[0]?.ibanDescription || null,
                        iban2: ibans[1]?.iban || null,
                        ibanDescription2: ibans[1]?.ibanDescription || null,

                        // Address Info
                        address: customerData.address || null,
                        city: cityId,
                        district: districtId, // This will trigger district fetching useEffect

                        // Other potentially relevant fields
                        middleman: customerData.middleman || null,
                        middlemanIban: customerData.middlemanIban || null,
                        customerContractRate: customerData.contractRate ?? prev.customerContractRate, // Use customerContractRate
                        customerIsMiddlemanContractBased: customerData.isMiddlemanContractBased === true,
                        customerMiddlemanContractRate: customerData.isMiddlemanContractBased === true ? (customerData.middlemanContractRate !== undefined ? customerData.middlemanContractRate : null) : null,
                        customerMiddlemanContractPrice: customerData.isMiddlemanContractBased === false ? (customerData.middlemanContractPrice !== undefined ? customerData.middlemanContractPrice : null) : null,
                        contractRate: customerData.contractRate ?? prev.contractRate, // Use nullish coalescing
                        hasContractArrived: customerData.contractOriginalArrived ? "yes" : "no",

                        // IMPORTANT: Reset fields that should NOT be auto-filled from customer search
                        // e.g., Accident details, License plate details (unless customer search returns them)
                        // licensePlate: null, // Reset if needed
                        // chassisNumber: null, // Reset if needed
                        // accidentDate: null, // Reset if needed
                        // ... reset other non-customer fields as necessary ...
                    };
                });

                // Müşteri ID'sini sakla
                setCustomerId(customerData.id);

            } else {
                // Customer not found OR extraction failed - Show WARNING toast
                // Check if API call itself was technically successful but returned no items
                if (response?.isSuccess && items.length === 0) {
                    console.log(`API call successful but no customer found for ${idType}: ${idValue}`);
                    toast.warning(`Bu ${idType === 'tcid' ? 'TC Kimlik' : 'Vergi'} numarası ile kayıtlı müşteri bulunamadı! Yeni müşteri olarak devam edebilirsiniz.`);
                } else {
                    // Handle cases where extraction failed or API returned unexpected structure
                    console.warn(`Could not extract valid customer data for ${idType}: ${idValue}. Response:`, response);
                    toast.warning('Müşteri bilgileri alınamadı veya format hatalı.'); // More generic warning
                }

                // Optionally clear some fields if no customer found
                // setFormData(prev => ({ ... }));
                setCustomerId(null); // Clear customer ID if not found or invalid
            }
        } catch (error) {
            console.error('Müşteri arama hatası:', error);
            // Show ERROR toast on API error
            toast.error('Müşteri bilgileri getirilirken bir hata oluştu.');
            setCustomerId(null); // Clear customer ID on error
        }
    };

    // --- UPDATED License Plate Search Function ---
    const handleLicensePlateSearch = async (plateNumber) => {
        if (!plateNumber || plateNumber.trim() === '') {
            toast.warning('Lütfen arama yapmak için bir plaka girin.');
            return;
        }
        // Clean the plate number for the search parameter (e.g., remove spaces)
        const searchTerm = plateNumber.replace(/\s/g, '');
        // Construct the query string
        const searchParam = `licensePlate=${searchTerm}`;

        if (!licensePlateApiUrl) {
            toast.error("License plate API endpoint is not configured.");
            return;
        }

        try {
            const response = await fetchFormData({
                apiEndpoint: `${licensePlateApiUrl}?${searchParam}`,
                page: 1,
                pageSize: 1,
            });

            console.log('License Plate Search Response:', response);

            let resultData = null;
            let items = [];

            // --- Refined Extraction Logic for License Plate ---
            if (response?.isSuccess && response?.data && Array.isArray(response.data.items)) {
                items = response.data.items;
            } else if (response?.items && Array.isArray(response.items)) {
                items = response.items;
            } else if (Array.isArray(response)) {
                items = response;
            } else if (response?.data && typeof response.data === 'object' && !Array.isArray(response.data) && response.data.licensePlateNumber) {
                // Check for licensePlateNumber as an indicator of a valid object
                resultData = response.data;
                console.log("Extracted single plate object directly from response.data");
            } else if (response && typeof response === 'object' && !Array.isArray(response) && response.licensePlateNumber) {
                // Check for licensePlateNumber at the root
                resultData = response;
                console.log("Extracted single plate object directly from response root");
            }

            // If items array was populated, take the first item
            if (items.length > 0) {
                resultData = items[0];
                console.log("Extracted plate data from items array:", resultData);
            }
            // --- End of Refined Extraction Logic ---


            // --- Updated Check: Check if resultData is a valid object with licensePlateNumber ---
            if (resultData && resultData.licensePlateNumber) {
                console.log('Found valid data for plate:', resultData);
                toast.success('Plaka bilgileri başarıyla getirildi.'); // Success only when plate data is found

                // --- Update formData logic remains the same ---
                setFormData(prev => {
                    // ... existing logic to map resultData to formData ...
                    const trafficPolicy = resultData.trafficInsurancePolicy;
                    const cascoPolicy = resultData.cascoInsurancePolicy;
                    const customer = resultData.customer;

                    return {
                        ...prev,
                        // Vehicle Info
                        licensePlate: resultData.licensePlateNumber || prev.licensePlate,
                        chassisNumber: resultData.carchassisNumber || null,
                        carBrand: resultData.carBrand || null,
                        carModel: resultData.carModel || null,
                        carYear: resultData.carYear || null,
                        hasCarSoldBefore: resultData.hasCarSoldBefore ? "yes" : "no",
                        isThereLovClaim: resultData.isThereLovClaim ? "yes" : "no",

                        // Insurance Info
                        trafficInsurancePolicy: {
                            trafficInsuranceProvider: trafficPolicy?.trafficInsuranceProvider
                                ? (typeof trafficPolicy.trafficInsuranceProvider === 'object' && !Array.isArray(trafficPolicy.trafficInsuranceProvider)
                                    ? [trafficPolicy.trafficInsuranceProvider.id]
                                    : (Array.isArray(trafficPolicy.trafficInsuranceProvider) ? trafficPolicy.trafficInsuranceProvider.map(p => p.id || p) : []))
                                : [],
                            trafficInsuranceNumber: trafficPolicy?.trafficInsuranceNumber || null,
                            trafficInsuranceStart: trafficPolicy?.trafficInsuranceStart
                                ? new Date(trafficPolicy.trafficInsuranceStart)
                                : null,
                            trafficInsuranceExpiry: trafficPolicy?.trafficInsuranceExpiry
                                ? new Date(trafficPolicy.trafficInsuranceExpiry)
                                : null
                        },
                        cascoInsurancePolicy: {
                            cascoInsuranceProvider: cascoPolicy?.cascoInsuranceProvider
                                ? (typeof cascoPolicy.cascoInsuranceProvider === 'object' && !Array.isArray(cascoPolicy.cascoInsuranceProvider)
                                    ? [cascoPolicy.cascoInsuranceProvider.id]
                                    : (Array.isArray(cascoPolicy.cascoInsuranceProvider) ? cascoPolicy.cascoInsuranceProvider.map(p => p.id || p) : []))
                                : [],
                            cascoInsuranceNumber: cascoPolicy?.cascoInsuranceNumber || null,
                            cascoInsuranceStart: cascoPolicy?.cascoInsuranceStart
                                ? new Date(cascoPolicy.cascoInsuranceStart)
                                : null,
                            cascoInsuranceExpiry: cascoPolicy?.cascoInsuranceExpiry
                                ? new Date(cascoPolicy.cascoInsuranceExpiry)
                                : null
                        },

                        // Customer Info (Conditional update)
                        ...(customer && {
                            customerId: customer.id || prev.customerId,
                            clientName: customer.customerType === 'Bireysel' ? (customer.clientName || prev.clientName) : prev.clientName,
                            companyName: customer.customerType === 'Kurumsal' ? (customer.companyName || prev.companyName) : prev.companyName,
                            tcid: customer.customerType === 'Bireysel' ? (customer.identityNumber || prev.tcid) : prev.tcid,
                            taxNumber: customer.customerType === 'Kurumsal' ? (customer.taxNumber || prev.taxNumber) : prev.taxNumber,
                            customerType: customer.customerType || prev.customerType,
                        })
                    };
                });
                // --- End of Update formData ---

            } else {
                // Plate data not found OR extraction failed - Show WARNING toast
                if (response?.isSuccess && items.length === 0) {
                    console.log(`API call successful but no data found for plate: ${plateNumber}`);
                    toast.warning(`Bu plaka (${plateNumber}) ile kayıtlı detaylı bilgi bulunamadı. Alanları manuel doldurabilirsiniz.`);
                } else {
                    console.warn(`Could not extract valid plate data for ${plateNumber}. Response:`, response);
                    toast.warning('Plaka bilgileri alınamadı veya format hatalı.');
                }

                // Optionally clear ONLY vehicle-specific fields if plate not found
                setFormData(prev => ({
                    ...prev,
                    licensePlate: plateNumber, // Keep the searched plate
                    chassisNumber: null,
                    carBrand: null,
                    carModel: null,
                    carYear: null,
                    trafficInsurancePolicy: { trafficInsuranceProvider: [], trafficInsuranceNumber: null, trafficInsuranceExpiry: null },
                    cascoInsurancePolicy: { cascoInsuranceProvider: [], cascoInsuranceNumber: null, cascoInsuranceExpiry: null },
                    // DO NOT clear customer fields here
                }));
            }

        } catch (error) {
            console.error('Plaka arama hatası:', error);
            toast.error('Plaka bilgileri getirilirken bir hata oluştu.');
            // Optionally clear fields on error too, or leave as is
            // setFormData(prev => ({ ... }));
        }
    };

    // --- Render Logic ---
    // Add check for loading states before rendering dependent components
    if (loadingStates) { // Show loading while states OR transitions are loading
        return (
            <Container fluid>
                <Breadcrumbs mainTitle={pageTitle} parent='Sayfalar' title={pageTitle} />
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <p>Durum bilgileri yükleniyor...</p>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }


    return (
        <Container fluid>
            <Breadcrumbs mainTitle={pageTitle} parent='Sayfalar' title={pageTitle} />
            <Row>
                <Col sm="12">
                    <Card>
                        <CallFormHeader
                            formData={formData}
                            handleCustomerTypeChange={handleCustomerTypeChange}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            resetForm={resetForm}
                            callFormState={currentFormState}
                        />
                        <CardBody>
                            <Form>
                                {['Yeni Çağrı Formu',
                                    'Düzeltme Bekleniyor',
                                    'Çağrı Formu Reddedildi',
                                    'Müvekkil Reddedildi',
                                    'Taslak',
                                    'Vekalet Bekleniyor',
                                    'Eksper Onay Bekleniyor',
                                    'Yönetici Onay Bekleniyor',
                                    'Ödeme Bekleniyor',
                                    'Evrak Bekleniyor',
                                    'Eksper İşlem Bekleniyor',
                                    'Eksper Rapor Bekleniyor',
                                    'Eksper Raporu Ödeme Bekleniyor',
                                    'Sigorta Başvuru Dilekçe Bekleniyor',
                                    'Tüm Form'].includes(currentFormState) && (
                                        <>
                                            <CustomerInfoForm
                                                callFormState={currentFormState}
                                                formData={formData}
                                                errors={errors}
                                                handleInputChange={handleInputChange}
                                                handleCustomerSearch={handleCustomerSearch}
                                                customerId={customerId}
                                                fieldPermissions={fieldPermissions}
                                                canEdit={canEdit}
                                            />
                                        </>
                                    )}

                                {['Yeni Çağrı Formu',
                                    'Çağrı Formu Reddedildi',
                                    'Müvekkil Reddedildi',
                                    'Düzeltme Bekleniyor',
                                    'Taslak',
                                    'Vekalet Bekleniyor',
                                    'Eksper Onay Bekleniyor',
                                    'Yönetici Onay Bekleniyor',
                                    'Ödeme Bekleniyor',
                                    'Tüm Form'].includes(currentFormState) && (
                                        <>
                                            <div style={{ height: "20px" }}></div>
                                            <hr className="mt-4 mb-4" />
                                            <div style={{ height: "20px" }}></div>

                                            <ContactInfoForm
                                                formData={formData}
                                                errors={errors}
                                                handleInputChange={handleInputChange}
                                                setFormData={setFormData} // Pass setFormData if needed by ContactInfoForm
                                                fieldPermissions={fieldPermissions} // <-- Pass permissions
                                                canEdit={canEdit}
                                            />
                                        </>
                                    )}

                                {['Yeni Çağrı Formu',
                                    'Çağrı Formu Reddedildi',
                                    'Müvekkil Reddedildi',
                                    'Düzeltme Bekleniyor',
                                    'Taslak',
                                    'Vekalet Bekleniyor',
                                    'Eksper Onay Bekleniyor',
                                    'Yönetici Onay Bekleniyor',
                                    'Ödeme Bekleniyor',
                                    'Tüm Form'].includes(currentFormState) && (
                                        <>
                                            <div style={{ height: "20px" }}></div>
                                            <hr className="mt-4 mb-4" />
                                            <div style={{ height: "20px" }}></div>

                                            <AccidentInfoForm
                                                formData={formData}
                                                errors={errors}
                                                setFormData={setFormData}
                                                handleInputChange={handleInputChange}
                                                handleLicensePlateSearch={handleLicensePlateSearch}
                                                fieldPermissions={fieldPermissions}
                                                canEdit={canEdit}
                                            />
                                        </>
                                    )}

                                {['Vekalet Bekleniyor', 'Tüm Form'].includes(currentFormState) && (
                                    <>
                                        <div style={{ height: "20px" }}></div>
                                        <hr className="mt-4 mb-4" />
                                        <div style={{ height: "20px" }}></div>

                                        <PowerOfAttorneyForm
                                            formData={formData}
                                            errors={errors}
                                            setFormData={setFormData}
                                            handleInputChange={handleInputChange}
                                            customerId={customerId}
                                            powerOfAttorneyId={powerOfAttorneyId}
                                            fieldPermissions={fieldPermissions}
                                            canEdit={canEdit}
                                        />
                                    </>
                                )}

                                {['Vekalet Bekleniyor',
                                    'Tüm Form'].includes(currentFormState) && (
                                        <>
                                            <div style={{ height: "20px" }}></div>
                                            <hr className="mt-4 mb-4" />
                                            <div style={{ height: "20px" }}></div>

                                            <AddressInfoForm
                                                formData={formData}
                                                errors={errors}
                                                handleInputChange={handleInputChange}
                                                cities={cities}
                                                filteredDistricts={filteredDistricts}
                                                handleCityChange={handleCityChange}
                                                fieldPermissions={fieldPermissions}
                                                canEdit={canEdit}
                                            />
                                        </>
                                    )}

                                {['Evrak Bekleniyor', 'Tüm Form'].includes(currentFormState) && (
                                    <>
                                        <div style={{ height: "20px" }}></div>
                                        <hr className="mt-4 mb-4" />
                                        <div style={{ height: "20px" }}></div>

                                        <DocumentRequestForm
                                            formData={formData}
                                            errors={errors}
                                            setFormData={setFormData}
                                            handleInputChange={handleInputChange}
                                            handleCounterPartyTypeChange={handleCounterPartyTypeChange}
                                            workFileTypes={workFileTypes}
                                            insuranceCompanies={insuranceCompanies}
                                            fieldPermissions={fieldPermissions}
                                            canEdit={canEdit}
                                        />
                                    </>
                                )}

                                {['Eksper İşlem Bekleniyor',
                                    'Eksper Rapor Bekleniyor',
                                    'Eksper Raporu Ödeme Bekleniyor',
                                    'Sigorta Başvuru Dilekçe Bekleniyor',
                                    'Tüm Form'].includes(currentFormState) && (
                                        <>
                                            <div style={{ height: "20px" }}></div>
                                            <hr className="mt-4 mb-4" />
                                            <div style={{ height: "20px" }}></div>
                                            <ExpertForm
                                                formData={formData}
                                                errors={errors}
                                                setFormData={setFormData}
                                                handleInputChange={handleInputChange}
                                                handleAddWorkFile={handleAddWorkFile}
                                                handleRemoveWorkFile={handleRemoveWorkFile}
                                                workFileTypes={workFileTypes}
                                                // Remove expert props
                                                // experts={experts} 
                                                // handleExpertChange={handleExpertChange} 
                                                insuranceCompanies={insuranceCompanies}
                                                callFormState={currentFormState}
                                                fieldPermissions={fieldPermissions}
                                                canEdit={canEdit}
                                                accidentFileId={accidentFileId}
                                                accidentFiles={accidentFiles}
                                            />
                                        </>
                                    )}

                                {['Eksper Rapor Bekleniyor', 'Tüm Form'].includes(currentFormState) && (
                                    <>
                                        <div style={{ height: "20px" }}></div>
                                        <hr className="mt-4 mb-4" />
                                        <div style={{ height: "20px" }}></div>
                                        <ExpertReportForm
                                            formData={formData}
                                            errors={errors}
                                            setFormData={setFormData}
                                            workFileTypes={workFileTypes}
                                            callFormState={currentFormState}
                                            fieldPermissions={fieldPermissions}
                                            canEdit={canEdit}
                                        />
                                    </>
                                )}

                                {['Sigorta Başvuru Dilekçe Bekleniyor', 'Tüm Form'].includes(currentFormState) && (
                                    <>
                                        <div style={{ height: "20px" }}></div>
                                        <hr className="mt-4 mb-4" />
                                        <div style={{ height: "20px" }}></div>
                                        <InsuranceCompanyReportForm
                                            formData={formData}
                                            errors={errors}
                                            setFormData={setFormData}
                                            workFileTypes={workFileTypes}
                                            fieldPermissions={fieldPermissions}
                                            canEdit={canEdit}
                                        />
                                    </>
                                )}

                                {['Ödeme Bekleniyor',
                                    'Tüm Form'].includes(currentFormState) && (
                                        <>
                                            <div style={{ height: "20px" }}></div>
                                            <hr className="mt-4 mb-4" />
                                            <div style={{ height: "20px" }}></div>
                                            <ExpenseCardList
                                                accidentFileId={accidentFileId}
                                                customerId={customerId}
                                                canEdit={canEdit}
                                                callformId={id}
                                                callFormState={currentFormState} // Çağrı formu durumunu geç
                                                initialCustomerContractRate={formData.licensePlateCustomerContractRate}
                                                initialIsMiddlemanContractBased={formData.licensePlateIsMiddlemanContractBased}
                                                initialMiddlemanContractRate={formData.licensePlateMiddlemanContractRate}
                                                initialMiddlemanContractPrice={formData.licensePlateMiddlemanContractPrice}
                                            />
                                        </>
                                    )}

                                {/* Kaza Dosyası Masrafları - Sadece Eksper Raporu Ödeme Bekleniyor durumunda göster */}
                                {['Eksper Raporu Ödeme Bekleniyor'].includes(currentFormState) && (
                                    <>
                                        <div style={{ height: "20px" }}></div>
                                        <hr className="mt-4 mb-4" />
                                        <div style={{ height: "20px" }}></div>
                                        <AccidentFileExpenseList
                                            canEdit={canEdit}
                                            customerId={customerId}
                                            callformId={id}
                                            callFormState={currentFormState}
                                            formData={formData}
                                            workFileTypes={workFileTypes}
                                            initialCustomerContractRate={formData.licensePlateCustomerContractRate}
                                            initialIsMiddlemanContractBased={formData.licensePlateIsMiddlemanContractBased}
                                            initialMiddlemanContractRate={formData.licensePlateMiddlemanContractRate}
                                            initialMiddlemanContractPrice={formData.licensePlateMiddlemanContractPrice}
                                        />
                                    </>
                                )}

                                {/* 
                                {['Ödeme Bekleniyor',
                                    'Eksper Raporu Ödeme Bekleniyor',
                                    'Tüm Form'].includes(currentFormState) && accidentFileId && (
                                        <>
                                            <div style={{ height: "20px" }}></div>
                                            <hr className="mt-4 mb-4" />
                                            <div style={{ height: "20px" }}></div>

                                            <PaymentCollectionCardList
                                                accidentFileId={accidentFileId}
                                                canEdit={canEdit}
                                                customerId={customerId}
                                                callformId={id}
                                            />
                                        </>
                                    )}
                                */}

                                {/* Comments and Files Sections */}
                                <div style={{ height: "20px" }}></div>
                                <hr className="mt-4 mb-4" />
                                <div style={{ height: "20px" }}></div>

                                <CommentsComponent
                                    formData={formData}
                                    errors={errors}
                                    handleInputChange={handleInputChange}
                                    callFormState={currentFormState}
                                    existingComments={existingComments}
                                    setExistingComments={setExistingComments}
                                    fieldPermissions={fieldPermissions}
                                    canEdit={canEdit}
                                />

                                <div style={{ height: "20px" }}></div>
                                <hr className="mt-4 mb-4" />
                                <div style={{ height: "20px" }}></div>

                                {/* Dosya yükleme için bilgilendirme mesajı */}
                                {!id && (
                                    <div className="alert alert-info mb-3">
                                        <i className="fa fa-info-circle me-2"></i>
                                        <strong>Bilgi:</strong> Dosya yükleyebilmek için önce çağrı formunu kaydetmeniz gerekiyor.
                                    </div>
                                )}

                                {/* Özel belge türleri için bilgilendirme */}
                                <div className="alert alert-warning mb-3">
                                    <i className="fa fa-exclamation-triangle me-2"></i>
                                    <strong>Not:</strong> <strong>VEKALETNAME</strong> belgeleri Vekalet Bilgileri bölümünden, <strong>SÖZLEŞME</strong> belgeleri ise Müşteri Bilgileri bölümünden yüklenmelidir.
                                </div>

                                {/* DataPool'dan gelen dosyalar - sadece görüntüleme */}
                                {isNewFormFromDataPool && (
                                    <FilesComponent
                                        onFilesChange={() => {}} // FilesComponent handles file management internally
                                        multiple={true}
                                        callFormReference={false} // DataPool objesine ait dosyalar
                                        referenceId={id} // DataPool ID
                                        typeFilter={['VEKALETNAME', 'SÖZLEŞME']} // VEKALETNAME ve SÖZLEŞME hariç tüm türler
                                        excludeTypes={true} // Bu türleri hariç tut
                                        title="Veri Havuzundan Gelen Belgeler"
                                        canEdit={false} // Sadece görüntüleme
                                    />
                                )}

                                {/* Çağrı formu belgeleri - yükleme ve düzenleme */}
                                <FilesComponent
                                    onFilesChange={() => {}} // FilesComponent handles file management internally
                                    multiple={true}
                                    callFormReference={true} // Çağrı formu için
                                    referenceId={isNewFormFromDataPool ? null : id} // Yeni formda null, mevcut formda CallForm ID
                                    typeFilter={['VEKALETNAME', 'SÖZLEŞME']} // VEKALETNAME ve SÖZLEŞME hariç tüm türler
                                    excludeTypes={true} // Bu türleri hariç tut
                                    title={isNewFormFromDataPool ? "Çağrı Formu Belgeleri" : "Belgeler"}
                                    canEdit={canEdit}
                                />
                            </Form>
                        </CardBody>

                        {/* Render Footer only if states/transitions are loaded and user can edit */}
                        {!loadingStates && dynamicStateTransitions && canEdit && (
                            <CallFormFooter
                                callFormState={currentFormState}
                                handleOperation={handleFormSubmission}
                                accidentFileId={accidentFileId}
                                customerId={customerId}
                                callformId={id}
                                initialCustomerContractRate={formData.licensePlateCustomerContractRate}
                                initialIsMiddlemanContractBased={formData.licensePlateIsMiddlemanContractBased}
                                initialMiddlemanContractRate={formData.licensePlateMiddlemanContractRate}
                                initialMiddlemanContractPrice={formData.licensePlateMiddlemanContractPrice}
                                formData={formData}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default CallForm;